window.Lemonade = window.Lemonade || {};

/**
 * Get initial cart JSON from the embedded script tag.
 * Use this only for initial page load - for fresh data after cart changes, use fetch('/cart.js')
 */
function getInitialCartJson() {
  const scriptTag = document.getElementById('current-cart-json');
  if (scriptTag) {
    try {
      return JSON.parse(scriptTag.textContent);
    } catch (e) {
      console.error('Failed to parse initial cart JSON:', e);
      return null;
    }
  }
  return null;
}

var bodyClasses = document.body.classList,
  sizeSelected = false,
  currentPrice,
  currentAvailable = false,
  currentSelected1 = null,
  currentSelected2 = null;

var isMobile = {
  Android: function () {
    return navigator.userAgent.match(/Android/i);
  },
  BlackBerry: function () {
    return navigator.userAgent.match(/BlackBerry/i);
  },
  iOS: function () {
    return navigator.userAgent.match(/iPhone|iPad|iPod/i);
  },
  Opera: function () {
    return navigator.userAgent.match(/Opera Mini/i);
  },
  Windows: function () {
    return navigator.userAgent.match(/IEMobile/i);
  },
  any: function () {
    return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
  }
};

function removeTrailingZeros(price) {
    return price.replace(/(\d+)([.,])00(?=\D|$)/g, '$1');
}

function cartLineCompareCents(item) {
  if (!window.liquidVars || !liquidVars.showCartComparePrice) return 0;
  const cents = parseInt((item.properties || {})['_compare-price'], 10);
  return cents > item.price ? cents : 0;
}

function cartCompareAtPrice(item) {
  const cents = cartLineCompareCents(item);
  if (!cents) return '';
  return removeTrailingZeros(Shopify.formatMoney(cents * item.quantity, moneyFormat));
}

function cartLineOriginalCents(item) {
  const compareCents = cartLineCompareCents(item);
  return compareCents ? compareCents * item.quantity : item.original_line_price;
}

function formatCartCents(cents) {
  return removeTrailingZeros(Shopify.formatMoney(cents, moneyFormat));
}

function cartTotalPricesHtml(cart) {
  const compareTotal = cart.items.reduce((sum, item) => sum + cartLineOriginalCents(item), 0);
  const totalHtml = `<span class="money">${formatCartCents(cart.total_price)}</span>`;
  if (compareTotal <= cart.total_price) return totalHtml;
  return `${totalHtml}<s class="cart-compare-price money cart-total-compare">${formatCartCents(compareTotal)}</s>`;
}

const CART_FOCUS_ROLES = [
  ['.cart-remove-btn', 'remove'],
  ['.Quantity', 'qty'],
  ['.up', 'up'],
  ['.down', 'down'],
  ['.cart-img a', 'img']
];
const CART_ROW = '.cart-flyout-item, .cart-item';

// re-rendering a cart replaces every row, so a keyboard user's focus would end up on <body>
function captureCartFocus(container) {
  const el = document.activeElement;
  if (!container || !el || !container.contains(el)) return null;
  try {
    if (!el.matches(':focus-visible')) return null;
  } catch (e) {
    return null;
  }
  const match = CART_FOCUS_ROLES.find(function (pair) { return el.matches(pair[0]); });
  if (!match) return null;
  const row = el.closest(CART_ROW);
  const keyed = row && row.querySelector('[data-key]');
  return {
    role: match[1],
    key: keyed ? keyed.getAttribute('data-key') : null,
    index: Array.prototype.indexOf.call(container.querySelectorAll(CART_ROW), row),
    scrollTop: container.scrollTop
  };
}

// the flyout close button lives in an inert drawer, so the cart page needs its own landing spot
function cartPageFocusFallback(container) {
  const empty = document.getElementById('cart-empty');
  if (empty && empty.getClientRects().length) return empty;
  return document.querySelector('#cart-page h1, #cart-page h2, .cart-page h1, .cart-page h2') || container;
}

function restoreCartFocus(container, saved, getFallback) {
  if (!container || !saved) return;
  const rows = container.querySelectorAll(CART_ROW);
  let row = null;
  if (saved.key) {
    row = Array.prototype.find.call(rows, function (candidate) {
      const keyed = candidate.querySelector('[data-key]');
      return keyed && keyed.getAttribute('data-key') === saved.key;
    });
  }
  // the line is gone when Remove was used, so fall back to whatever took its place
  if (!row && saved.index >= 0 && rows.length) row = rows[Math.min(saved.index, rows.length - 1)];
  const match = CART_FOCUS_ROLES.find(function (pair) { return pair[1] === saved.role; });
  const target = (row && match && row.querySelector(match[0])) || (typeof getFallback === 'function' ? getFallback(container) : null);
  if (!target) return;
  if (target.tabIndex < 0 && !target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
  container.scrollTop = saved.scrollTop;
  target.focus({ preventScroll: true });
}

// API for utility functions
var Utilities = (function () {

  return {

    handleize: function (str) {
      return str.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
    },

    // card images are built from bare urls, so pull the text alternative off the card itself
    cardImageAlt: function (el) {
      const card = el && el.closest ? el.closest('.grid-item, .item-product') : null;
      if (!card) return 'Product image';
      const labelled = card.querySelector('.product-card-link[aria-label]');
      const label = labelled && labelled.getAttribute('aria-label');
      if (label && label.trim()) return label.trim();
      const heading = card.querySelector('h3');
      const text = heading && heading.textContent;
      return (text && text.trim()) || 'Product image';
    },

    getQueryParam: function (name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[\[\]]/g, '\\$&');
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },

    getProductGiftGamification: async () => {
      const productHandle = window.productGiftHandle
      if (!productHandle) return false;
      const url = `/products/${productHandle}.json`
      return fetch(url)
        .then(response => response.json())
        .then(data => {
          const variantsAvailable = data.product.variants.filter(x => x.inventory_quantity > 0)
          return {
            productId: data.product.id,
            firstVariantId: variantsAvailable
          }
        })
    },

    getColorNameByCode (colorValue) {
      const colorValuesElement = document.querySelector('[data-colors-list]');
      const colorValues = JSON.parse(colorValuesElement.textContent);
      const color = colorValues[colorValue.toUpperCase()];
      return color || colorValue;
    },

    // Point the hidden variant <select> of a gift pop-up item at the variant
    // matching every picked option value. The pop-up renders one row of pickers
    // per option (Size, Color, ...), so the variant is only known once they are
    // combined - see snippets/gift-popup.liquid.
    selectGiftVariant: (item) => {
      const select = item.querySelector("select[name='id']");
      if (!select) return;

      const picked = {};
      item.querySelectorAll(".gift-option-value.active").forEach(value => {
        picked[value.getAttribute("data-option-position")] = value.getAttribute("data-option-value");
      });

      const positions = Object.keys(picked);
      const variant = Array.from(select.options).find(option =>
        positions.every(position => option.getAttribute(`data-option${position}`) === picked[position])
      );
      if (variant) select.value = variant.value;

      Utilities.setGiftImage(item, variant);
      Utilities.toggleGiftSoldOut(item, variant);
    },

    // Warm the variant images once the pop-up is on screen, so switching colour
    // swaps instantly instead of showing an empty box.
    preloadGiftImages: (item) => {
      item.querySelectorAll("option[data-image]").forEach(option => {
        const src = option.getAttribute("data-image");
        if (src) new Image().src = src;
      });
    },

    // Show the picked variant's own image, falling back to the product image
    // for variants that don't have one.
    setGiftImage: (item, variant) => {
      const image = item.querySelector(".image img");
      if (!image) return;

      const src = (variant && variant.getAttribute("data-image")) || image.getAttribute("data-default-src");
      if (src && image.getAttribute("src") !== src) image.setAttribute("src", src);
    },

    // A sold out combination must not be addable: block the button and swap its
    // label for the merchant's sold out copy.
    toggleGiftSoldOut: (item, variant) => {
      const button = item.querySelector(".add-to-cart-gamification");
      if (!button) return;

      const isAvailable = !!variant && variant.getAttribute("data-available") === "true";
      const label = isAvailable
        ? button.getAttribute("data-add-to-cart-text")
        : button.getAttribute("data-sold-out-text");

      button.disabled = !isAvailable;
      button.classList.toggle("disabled", !isAvailable);
      if (label) button.value = label;
    },

    giftVariantIds: () => {
      const giftOptions = document.querySelectorAll(".gamification-modal select[name='id'] option[value]");
      const isVariantId = (id) => Number.isInteger(id) && id > 0;
      return new Set(Array.from(giftOptions).map(option => Number(option.value)).filter(isVariantId));
    },

    giftLimit: () => {
      const quantityElement = document.querySelector(".gamification-quantity");
      const limit = parseInt(quantityElement?.getAttribute("data-gamification-gift-quantity"), 10);
      return Number.isInteger(limit) && limit > 0 ? limit : 1;
    },

    giftQuantityInCart: (cart) => {
      const giftIds = Utilities.giftVariantIds();
      const cartItems = cart?.items || [];
      return cartItems
        .filter(item => giftIds.has(Number(item.variant_id)))
        .reduce((quantity, item) => quantity + item.quantity, 0);
    },

    isGiftVariant: (variantId) => Utilities.giftVariantIds().has(Number(variantId)),

    submittedVariantId: (data) => {
      if (typeof data === 'string') return new URLSearchParams(data).get('id');
      return data && data.id;
    },

    shouldBlockGiftAdd: (variantId, cart) => {
      if (!Utilities.isGiftVariant(variantId)) return false;
      return Utilities.giftQuantityInCart(cart) >= Utilities.giftLimit();
    },

    removeGiftLines: (cart) => {
      const giftIds = Utilities.giftVariantIds();
      const updates = {};
      for (const item of (cart?.items || [])) {
        if (giftIds.has(Number(item.variant_id))) updates[item.variant_id] = 0;
      }
      if (!Object.keys(updates).length) return;

      $.ajax({
        url: '/cart/update.js', type: 'post', dataType: 'json',
        data: { updates: updates },
        success: () => {
          Utilities.updateCart(false, true);
        }
      });
    },

    isGiftProductType: (value) => String(value ?? '').trim().toLowerCase() === 'gifts',

    openModalGift: (cart) => {
      // While the gift is being added the cart is rendered from data that still
      // predates the add (the pre-add /cart.js call in addToCart and the cached
      // #current-cart-json). Those renders must not re-open the pop-up the click
      // just closed, otherwise it flashes back for a couple of seconds until a
      // fresh cart arrives. addToCart holds the lock for the add request.
      if (window.__giftAtcLock) return;

      const gamificationModal = document.querySelector(".gamification-modal");
      // const gamificationATC = document.querySelector(".add-to-cart-gamification");
      gamificationModal.classList.add("open");
      $('#ScreenOverlay').addClass('Active');

      // The pop-up highlights the first value of every option, so make the
      // hidden <select> agree with it before the shopper touches anything.
      gamificationModal.querySelectorAll(".gamification-modal-product-item")
        .forEach(item => {
          Utilities.selectGiftVariant(item);
          Utilities.preloadGiftImages(item);
        });

      gamificationModal.onclick = async ({ target }) => {

        // if (target.classList.contains("add-to-cart-gamification")) {
        //   gamificationModal.classList.remove("open");
        //   $('#ScreenOverlay').removeClass('Active');
        // }

        if (target.closest(".icon-close, .gamification-modal__close")) {
          gamificationModal.classList.remove("open");
          $('#ScreenOverlay').removeClass('Active');
        }

        if (target.classList.contains("gift-option-value")) {
          const group = target.closest(".gift-popup-option");
          if (group) {
            group.querySelectorAll(".gift-option-value").forEach(value => value.classList.remove("active"));
          }
          target.classList.add("active");

          const item = target.closest(".gamification-modal-product-item");
          if (item) Utilities.selectGiftVariant(item);
        }

        if (target.classList.contains("gender-selector")) {
          if (target.getAttribute("data-target") === "men") {
            const freeGiftWomen = document.querySelector(".free-gift-women");
            const freeGiftMen = document.querySelector(".free-gift-men");
            if (freeGiftWomen) freeGiftWomen.classList.remove("active");
            if (freeGiftMen) freeGiftMen.classList.add("active");
            document.querySelectorAll(".gender-selector-women").forEach(item => item.classList.remove("active"));
            document.querySelectorAll(".gender-selector-men").forEach(item => item.classList.add("active"));
          } else {
            const freeGiftWomen = document.querySelector(".free-gift-women");
            const freeGiftMen = document.querySelector(".free-gift-men");
            const genderSelectorMen = document.querySelector(".gender-selector-men");
            if (freeGiftWomen) freeGiftWomen.classList.add("active");
            if (freeGiftMen) freeGiftMen.classList.remove("active");
            if (genderSelectorMen) genderSelectorMen.classList.remove("active");
            document.querySelectorAll(".gender-selector-women").forEach(item => item.classList.add("active"));
            document.querySelectorAll(".gender-selector-men").forEach(item => item.classList.remove("active"));
          }
        }
      }
    },

    calculatePercentGamification: (totalPrice, tier1 = 75, tier2 = 300) => {
      const breakpoints = [0, tier1, (tier2 - tier1), tier2];
      const progressBarWidths = [0, 25, 50, 90, 100];
      const index = breakpoints.findIndex(b => totalPrice <= b);

      if (totalPrice >= tier2) return 100;

      return progressBarWidths[index];
    },

    updateSteps: (currentProgress, productsCount = 0) => {
      const steps = [
        document.querySelector('.step:nth-child(1)'),
        document.querySelector('.step:nth-child(2)'),
        document.querySelector('.step:nth-child(3)')
      ];

      function isStepComplete(index) {
        if (currentProgress >= 100) {
          return index < 3;
        } else if (currentProgress >= 50) {
          return index < 2;
        } else {
          return index < 1;
        }
      }
      steps.forEach((step, index) => {
        if (index === 2 && productsCount >= 3) {
          step.classList.add('complete');
          return;
        }
        if (isStepComplete(index)) {
          step.classList.add('complete');
        } else {
          step.classList.remove('complete');
        }
      });
    },

    getCollectionsFromCartProducts: async (cartItems, collectionName = "") => {
      const STOREFRONT_TOKEN = ((window.LIVE && window.LIVE.storefrontToken) || 'ed761c0d0f68bc596e5e4dd4e29e6407');
      const SHOP_DOMAIN = ((window.LIVE && window.LIVE.shopDomain) || 'live-ecom.myshopify.com');
      const collectionMap = {};
      const productsQuantity = [];
      const getCollectionsToDiscount = () => {
        const el = document.querySelector(".collection-name");
        const raw = el?.getAttribute("data-collection-name") || collectionName;
        return raw.split(";").map(v => v.trim()).filter(Boolean);
      };
      const collectionsToDiscount = getCollectionsToDiscount();

      const productQuery = `
        query GetProductCollections($handle: String!) {
          product(handle: $handle) {
            collections(first: 150) {
              edges {
                node {
                  id
                  title
                  handle
                  metafields(identifiers: [
                    {namespace: "custom", key: "main_color"}
                  ]) {
                    value
                  }
                }
              }
            }
          }
        }

      `;

      for (const item of cartItems) {
        if (Utilities.isGiftProductType(item.product_type)) continue;

        try {
          const response = await fetch(`https://${SHOP_DOMAIN}/api/2023-04/graphql.json`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
            },
            body: JSON.stringify({
              query: productQuery,
              variables: { handle: item.handle }
            })
          });

          const json = await response.json();
          const collections = json?.data?.product?.collections?.edges?.map(e => e.node) || [];
          const relevantCollections = collections.filter(col =>
            collectionsToDiscount.includes(col.title)
          );

          if (relevantCollections.length > 0) {
            const mainColors = relevantCollections.flatMap(col => {
              return (col.metafields || []).flatMap(meta => {
                try {
                  return JSON.parse(meta.value?.replace(/\\/g, "") || "[]");
                } catch {
                  return [];
                }
              });
            });
            const itemColor = item.variant_options[1];
            if (mainColors.length == 0) {
              productsQuantity.push(item);
            }
            if (mainColors.includes(itemColor)) {
              productsQuantity.push(item);
            }
          }
        } catch (error) {
          console.error(`Erro ao buscar coleções para o item "${item.handle}":`, error);
        }
      }
      return {
        byProductHandle: collectionMap,
        items: productsQuantity,
        topCollectionCount: productsQuantity.reduce((sum, item) => sum + item.quantity,0)
      };
    },

    progressGamification: (totalPrice = 0, itemsQuantity) => {
      const ItemsQuantity = itemsQuantity;
      const gamificationQuantity = document.querySelector(".gamification-quantity").getAttribute("data-gamification-quantity");

      if (resetGamification) {
        let tier1PriceReset = parseInt(parseFloat(document.querySelector(".step-gamification-1").getAttribute("data-gamification-tier-1-price")) * Shopify.currency.rate);
        let tier2PriceReset = parseInt(parseFloat(document.querySelector(".step-gamification-2").getAttribute("data-gamification-tier-2-price")) * Shopify.currency.rate);

        document.querySelector(".step-gamification-1").setAttribute("data-gamification-tier-1-price", tier1PriceReset);
        document.querySelector(".step-gamification-2").setAttribute("data-gamification-tier-2-price", tier2PriceReset);

        document.querySelector(".gamification-value-1").innerHTML = removeTrailingZeros(Shopify.formatMoney(tier1PriceReset, moneyFormat));
        if (tier2PriceReset > 0){
          document.querySelector(".gamification-value-2").innerHTML = removeTrailingZeros(Shopify.formatMoney(tier2PriceReset, moneyFormat));
        }

        resetGamification = false;
      }

      const progressBarContent = document.querySelector("#progress-bar");
      const progressGamification1 = document.querySelector(".step-gamification-1");
      const progressGamification2 = document.querySelector(".step-gamification-2");

      const tier1 = parseInt(progressGamification1.getAttribute("data-gamification-tier-1-price"));
      const tier2 = parseInt(progressGamification2.getAttribute("data-gamification-tier-2-price"));

      const freeShippingText = document.querySelector(".gamification-free-shipping").getAttribute("data-gamification-free-shipping");
      const freeShippingUnlockedText = document.querySelector(".gamification-free-shipping-unlocked").getAttribute("data-gamification-free-shipping-unlocked");
      const freeGiftText = document.querySelector(".gamification-free-gift").getAttribute("data-gamification-free-gift");
      const freeGiftUnlockedText = document.querySelector(".gamification-free-gift-unlocked").getAttribute("data-gamification-free-gift-unlocked");

      if (progressBarContent.getAttribute("product-gift-handle")) {
        window.productGiftHandle = progressBarContent.getAttribute("product-gift-handle");
      }
      const isOnlyFreeShipping = progressBarContent.getAttribute("data-only-free-shipping");
      const progressBar = document.querySelector("#progress-bar .progress");
      const awayFreeGift = document.querySelector("#progress-bar .message-free-gift");
      const totalFreeShipping = tier1 - totalPrice;
      const totalFreeGift = tier2 - totalPrice;
      const currentProgressPrice = Utilities.calculatePercentGamification(totalPrice, tier1, tier2);

      if (currentProgressPrice) {
        if (isOnlyFreeShipping !== "false") {
          if (totalPrice >= 75) {
            progressBar.style.width = "100%";
            awayFreeGift.innerHTML = `${freeShippingText.replace('[value]', removeTrailingZeros(Shopify.formatMoney((totalFreeShipping > 0 ? totalFreeShipping : 0), moneyFormat)))}`;
          } else {
            progressBar.style.width = "80%";
            awayFreeGift.innerHTML = `${freeShippingText.replace('[value]', removeTrailingZeros(Shopify.formatMoney((totalFreeShipping > 0 ? totalFreeShipping : 0), moneyFormat)))}`;
          }
        } else {
          progressBar.style.width = `${currentProgressPrice}%`;

          if (currentProgressPrice >= 50 && currentProgressPrice < 100) {
              awayFreeGift.innerHTML = `${freeShippingUnlockedText.replace('[quantity]', removeTrailingZeros(Shopify.formatMoney((totalFreeGift > 0 ? totalFreeGift : 0), moneyFormat)))}`;
          } else if (currentProgressPrice >= 100) {
            if (ItemsQuantity < gamificationQuantity) {
              progressBar.style.width = "90%";
              var step = document.querySelector(".gamification-value-2");

              awayFreeGift.innerHTML = `${freeGiftText.replace('[quantity]', gamificationQuantity - ItemsQuantity)}`;
            }
            else {
              var step = document.querySelector(".gamification-value-2");

              awayFreeGift.innerHTML = `${freeGiftUnlockedText}`;
            }
          } else {
            awayFreeGift.innerHTML = `${ freeShippingText.replace('[value]', removeTrailingZeros(Shopify.formatMoney((totalFreeShipping > 0 ? totalFreeShipping : 0), moneyFormat)))}`;
          }
        }
        Utilities.updateSteps(currentProgressPrice, ItemsQuantity);
      }
    },

    gamification: async () => {    
      const cart = getInitialCartJson() || await fetch('/cart.js').then(r => r.json());
      const collectionsInfo = await Utilities.getCollectionsFromCartProducts(cart.items);
      const itemsQuantity = collectionsInfo.topCollectionCount;
      const items = collectionsInfo.items;
      const gamificationQuantity = document.querySelector(".gamification-quantity").getAttribute("data-gamification-quantity");

      Utilities.progressGamification(cart.total_price, itemsQuantity);

      for (const item of cart.items) {
        const colorValue = item.options_with_values.find(x => x.name === 'Color');
        if (colorValue) {
          const color = Utilities.getColorNameByCode(colorValue.value);
          if (color) {
            document.querySelectorAll(`.item-cart-${item.handle}-${item.id} .colorName`).forEach(function (el) {
              el.innerHTML = `Color: ${color}`;
            });
          }
        }
      }

      if (window.productGiftHandle) {
        const progressGamification2 = document.querySelector('.step-gamification-2');
        const tier2 = parseInt(progressGamification2.getAttribute('data-gamification-tier-2-price')) * Shopify.currency.rate;

        if ((cart.total_price) >= tier2 && itemsQuantity >= gamificationQuantity) {
          if (Utilities.giftQuantityInCart(cart) < Utilities.giftLimit()) {
            Utilities.openModalGift(cart);
          } else {
            const gamificationModal = document.querySelector(".gamification-modal");
            gamificationModal.classList.remove("open");
            $('#ScreenOverlay').removeClass('Active');
          }
        } else {
          Utilities.removeGiftLines(cart);
        }
      }
    },

    getCurrentCart: async () => {
      const initialCart = getInitialCartJson();
      if (initialCart) return initialCart;
      return await fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          return cart
        })
    },

    getVariantsMetafields: async (handle) => {
       const query = `
        query getProductVariants($handle: String!) {
          product(handle: $handle) {
            id
            title
            handle
            variants(first: 50) {
              edges {
                node {
                  id
                  title
                  sku
                  price {
                    amount
                    currencyCode
                  }
                  metafields(identifiers: [
                    { namespace: "custom", key: "images" }
                  ]) {
                    key
                    namespace
                    type
                    value
                  }
                }
              }
            }
          }
        }
      `;

      return await fetch(((window.LIVE && window.LIVE.storefrontUrl) || 'https://live-ecom.myshopify.com/api/2025-07/graphql.json'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': ((window.LIVE && window.LIVE.storefrontToken) || 'ed761c0d0f68bc596e5e4dd4e29e6407')
        },
        body: JSON.stringify({
          query,
          variables: {
            handle: handle
          }
        })
      }).then(res => res.json())
      .then(data => { return data?.data?.product?.variants ?? null })
    },

    getImagesByMediaId: async (idImage) => {
      const query = `
        query getFile(\$id: ID!) {
          node(id: \$id) {
            ... on MediaImage {
              id
              alt
              image {
                url
                width
                height
              }
            }
          }
        }
      `;

      return await fetch(((window.LIVE && window.LIVE.storefrontUrl) || 'https://live-ecom.myshopify.com/api/2025-07/graphql.json'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': ((window.LIVE && window.LIVE.storefrontToken) || 'ed761c0d0f68bc596e5e4dd4e29e6407')
        },
        body: JSON.stringify({
          query,
          variables: {
            id: idImage
          }
        })
      }).then(res => res.json())
      .then(data => { return data })
    },

    getProductsByCollection: async () => {
      let url = new URL(window.location.href)
      let collectionName = "";
      if (url.pathname === "/") {
        collectionName = document.querySelector(".content-collection").getAttribute("data-collection-handle")
      } else {
        collectionName = url.pathname.split("/")[2]
      }

      fetch(`/collections/${collectionName}/products.json?limit=6`)
        .then(response => response.json())
        .then(data => {
          if (data.products.length >= 3) {
            const render = data.products.map(product => (`
                  <div class="product">
                    <a href="/collections/${collectionName}/products/${product.handle}">
                      <div class="image"><img src="${product.images[0].src}" alt="${product.title.replace(/["]/g, "&quot;")}" /></div>
                      <h4>${product.title}</h4>
                      <span class="money">${ Shopify.formatMoney(product.variants[0].price, moneyFormat) }</span>
                    </a>
                  </div>
               
            `)).join("");
            document.querySelector(".sidecart-popup__body").classList.add("show")
            document.querySelector(".sidecart-popup__body").innerHTML = `
              <h3>pairs great with</h3>
              <div class="sidecart-popup__body-products">${render}</div>
            `
          }else{
            document.querySelector(".sidecart-popup__body").classList.remove("show")
          }
        })
    },

    handleSidecartPopUp: async (productTitle) => {
      const sidecartPopupContainer = document.querySelector(".sidecart-popup");
      const sidecartProductTitle = document.querySelector(".sidecart-popup .sidecart-product-title");
      sidecartPopupContainer.classList.add("show");
      sidecartProductTitle.innerHTML = productTitle;


      Utilities.getProductsByCollection()
      Utilities.closeSavedCartReturn();

      $('#ScreenOverlay').addClass('Active');
      sidecartPopupContainer.onclick = ({ target }) => {
        if (target.classList.contains("btn-continue") || target.classList.contains("close")) {
          sidecartPopupContainer.classList.remove("show");
          $('#ScreenOverlay').removeClass('Active');
        }

        if (target.classList.contains("btn-open-bag")) {
          sidecartPopupContainer.classList.remove("show");
          Utilities.openCartFlyout();
          $('#ScreenOverlay').removeClass('Active');
        }
      }
    },

    isMobileDevice: () => {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    },

    // focus the panel itself, not the close button: opening by mouse then shows no
    // ring, while the first Tab still lands on the close button and does show one
    focusIntoCartFlyout: function () {
      const flyout = Lemonade.cache.$cartFlyout[0];
      if (!flyout) return;
      if (!flyout.hasAttribute('tabindex')) flyout.setAttribute('tabindex', '-1');

      // the panel fades in from visibility:hidden, so focus only lands once it paints
      let tries = 0;
      (function focusPanel() {
        if (!flyout.classList.contains('Show')) return;
        flyout.focus({ preventScroll: true });
        if (document.activeElement === flyout || tries > 10) return;
        tries++;
        requestAnimationFrame(focusPanel);
      })();
    },

    openCartFlyout: function () {
      // every cart change re-opens an already open flyout, and focus must not jump then
      const wasOpen = Lemonade.cache.$cartFlyout.hasClass('Show');

      Utilities.resizeCartFlyout();
      Utilities.closeSavedCartReturn();
      Utilities.hideChatButton();
      
      if (window.innerWidth <= 767) {
        Lemonade.cartScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
        Lemonade.scrollNo();
        Lemonade.cache.$body.css({
          'position': 'fixed',
          'top': -Lemonade.cartScrollPosition + 'px',
          'width': '100%'
        });
      }
      
      Lemonade.cache.$cartFlyout.removeAttr('inert');
      Lemonade.cache.$cartFlyout.addClass('Show');
      $('#CartTrigger').attr('aria-expanded', 'true');
      if (!wasOpen) Utilities.focusIntoCartFlyout();
    },

    closeCartFlyout: function () {
      // hand focus back to the trigger, but only when it is still inside the panel
      const flyout = Lemonade.cache.$cartFlyout[0];
      const returnFocus = !!flyout && flyout.contains(document.activeElement);

      Utilities.showChatButton();
      Lemonade.cache.$cartFlyout.removeClass('Show');
      $('#CartTrigger').attr('aria-expanded', 'false');

      if (returnFocus) {
        const trigger = document.getElementById('CartTrigger');
        if (trigger) trigger.focus({ preventScroll: true });
      }

      // visibility:hidden alone does not hold: the express checkout widgets set
      // visibility:visible on themselves, so Tab reached them - and Enter on the
      // hidden Shop Pay button started a checkout
      Lemonade.cache.$cartFlyout.attr('inert', '');

      if (window.innerWidth <= 767) {
        Lemonade.isRestoringScroll = true;
        
        Lemonade.scrollYes();
        Lemonade.cache.$body.css({
          'position': '',
          'top': '',
          'width': ''
        });
        
        window.scrollTo(0, Lemonade.cartScrollPosition);
        
        var headerFlex = document.getElementById('header-flex');
        if (headerFlex) {
          headerFlex.classList.remove('hidden');
        }
        
        setTimeout(function() {
          Lemonade.isRestoringScroll = false;
        }, 100);
      }
    },

    closeSavedCartReturn: function() {
      Lemonade.cache.$cartSavedReturn.removeClass('open');
    },

    showChatButton: function() {
      $('#shopify-chat').show();
    },

    hideChatButton: function() {
      $('#shopify-chat').hide();
    },

    createCookie: () => {
      var expiration = new Date(Date.now() + 60 * 1000);
      document.cookie = `cart_saved=true; expires=${expiration.toUTCString()}; path=/`;
    },

    updateCartJson: function (cart) {
      const currentCartJson = document.getElementById("current-cart-json");

      if (currentCartJson) {
        currentCartJson.textContent = JSON.stringify(cart);
      }
    },

    addProductToCart: async function (data, successCallback, errorCallback, source) {
      const submittedVariantId = Utilities.submittedVariantId(data);
      if (Utilities.isGiftVariant(submittedVariantId)) {
        const cart = await fetch('/cart.js').then(r => r.json());
        if (Utilities.shouldBlockGiftAdd(submittedVariantId, cart)) {
          if (typeof errorCallback === 'function') errorCallback();
          return;
        }
      }

      $.ajax({
        url: '/cart/add.js', type: 'post', dataType: 'json',
        data: data,
        success: function (data, textStatus, jqXHR) {
          if (textStatus === 'success') {
            $('#ScreenOverlay').removeClass('Active');
            $('.GridWrapper').find('.btn-addtocart').css('display', 'none');
            Lemonade.scrollYes();
            if (liquidVars.oneTreeProdID && liquidVars.oneTreeProdHandle && source != 'pdp') {
              $.ajax({
                url: '/cart/add.js', type: 'post', dataType: 'json',
                data: { id: parseInt(liquidVars.oneTreeProdID), quantity: 1 },
                success: function (data, textStatus, jqXHR) {
                  Utilities.updateCart(successCallback, true);
                  Utilities.createCookie()
                }
              });
            } else {
              Utilities.updateCart(successCallback, true);
            }
            $(`#product-${data.product_id}`).addClass('ItemAdded');
            setTimeout(function () {
              $(`#product-${data.product_id}`).removeClass('ItemAdded');
            }, 3000);
          }
        },
        error: function (jqXHR, textStatus, errorThrown) {
          errorCallback
            ? errorCallback(jqXHR.responseJSON.description)
            : alert(jqXHR.responseJSON.description);
        }
      });
    },

    addProductsToCart: function (productQueue) {
      if (productQueue.length) {
        var data = productQueue.shift();
        $.ajax({
          url: '/cart/add.js', type: 'post', dataType: 'json',
          data: data,
          success: function (data, textStatus, jqXHR) {
            Utilities.addProductsToCart(productQueue);
            Utilities.createCookie()
          },
          error: function (jqXHR, textStatus, errorThrown) {
            errorCallback && errorCallback(jqXHR.responseJSON.description);
          }
        });
      } else {
        document.location.href = '/cart';
      }
    },

    updateCartQuantity: function (data, successCallback, errorCallback, flyout) {
      var isFlyout = flyout;

      // Determine which cart was updated and call appropriate function
      function cartSource(cart) {

        if (liquidVars.oneTreeProdID && liquidVars.oneTreeProdHandle) {
          var nonTreeItemCount = 0;

          $.each(cart.items, function (i, el) {
            if (el.handle != liquidVars.oneTreeProdHandle) {
              nonTreeItemCount = nonTreeItemCount + el.quantity;
            }
          });

          $.ajax({
            url: '/cart/change.js',
            type: 'post',
            dataType: 'json',
            data: { id: liquidVars.oneTreeProdID, quantity: nonTreeItemCount },
            success: function (cart) {
              Utilities.updateCartJson(cart);
              if (isFlyout) {
                Utilities.updateCart(cart, true);
              } else {
                Utilities.updateCartPage(cart, false);
              }
            },
            error: function (XMLHttpRequest, textStatus) {
              Shopify.onError(XMLHttpRequest, textStatus);
            }
          });
        } else {
          if (isFlyout) {
            Utilities.updateCart(cart, true);
          } else {
            Utilities.updateCartPage(cart, false);
          }
        }
      }

      $.ajax({
        url: '/cart/change.js',
        type: 'post',
        dataType: 'json',
        data: data,
        success: function (cart) {
          Utilities.updateCartJson(cart);
          cartSource(cart);
        },
        error: function (XMLHttpRequest, textStatus) {
          Shopify.onError(XMLHttpRequest, textStatus);
        }
      });
    },

    cartTotalHtml: function (cart) {
      return `TOTAL <span class="cart-total-prices">${cartTotalPricesHtml(cart)}</span>`;
    },

    updateCart: function (callback, openFlyout, addedProduct) {
      $.getJSON('/cart.js', function (cart) {
        Utilities.updateCartJson(cart);
        const isMobileDevice = Utilities.isMobileDevice();
        Utilities.renderCartFlyout(cart, !isMobileDevice ? openFlyout : false);

        var totalCurrencyMob = document.querySelector("#Subtotal");
        if (totalCurrencyMob) {
          totalCurrencyMob.innerHTML = Utilities.cartTotalHtml(cart);
        }

        document.querySelector(".btn-checkout-submit").setAttribute("disabled", "disabled");
        setTimeout(() => {
          document.querySelector(".btn-checkout-submit").removeAttribute("disabled");
        }, 1500)
        if (isMobileDevice && !document.querySelector("#CartFlyout").classList.contains("Show")) {
          if (cart.items.length > 0) {
            const productsFilter = cart.items.filter(x => x.product_title !== "One Tree Planted")
            Utilities.handleSidecartPopUp(productsFilter[0].product_title)
          }
        }
        if (typeof callback === 'function') {
          callback(cart);
        }
      });
    },

    updateCartPage: function (cart) {
      $.getJSON('/cart.js', function (cart) {
        Utilities.updateCartJson(cart);
        Utilities.renderCartPage(cart);
      });
    },

    changeCart: function (cartItemsQueue) {
      if (cartItemsQueue.length) {
        var data = cartItemsQueue.shift();
        $.ajax('cart/change.js', {
          data: data,
          dataType: 'json',
          success: function (cart) {
            Utilities.updateCartJson(cart);
            Utilities.changeCart(cartItemsQueue);
          }
        })
      } else {
        window.location.reload();
      }
    },

    setCartData: function (cart) {
      Utilities.updateCartJson(cart);
      var items = [],
        nonTreeItemCount = 0;

      for (const variant of cart.items) {
        let urlList = [];
        try {
          const result = Utilities.getVariantsMetafields(variant.handle);

          if (result?.edges?.length) {
            const variants = result.edges
              .map(f => f.node)
              .filter(k => k.id === 'gid://shopify/ProductVariant/' + variant.id);

            const metafields = variants.flatMap(v => v.metafields || []);
            const rawList = metafields.flatMap(mf => {
              try { return JSON.parse(mf.value); } catch { return []; }
            });

            urlList = rawList;
          }
        } catch (err) {
          console.error("Erro metafields:", err);
        }

        if (urlList.length > 0) {
          const gid = urlList[0];
          const imageResult = Utilities.getImagesByMediaId(gid);
          variant.image = imageResult?.data?.node?.image?.url || null;
        }

        const imgSmall = variant.image ? variant.image.replace(/^(.+)(\..+)$/, '$1_medium$2') : '';
        const option_label = (variant.handle == 'gift-card') ? 'Amount' : 'Color';

        if (variant.handle != liquidVars.oneTreeProdHandle) {
          nonTreeItemCount += variant.quantity;
        }

        for (let i = 0; i < variant.options_with_values.length; i++) {
          if (variant.options_with_values[i].name === 'Color') {
            variant.options_with_values[i].value = variant.options_with_values[i].value.toLowerCase();
          }
        }
        var price_qty = variant.price * variant.quantity, errorClass = '';
        const sizeOption = variant.options_with_values.find(x => x.name === "Size");
        const sizeValue = sizeOption ? sizeOption.value : null;
        const showColor = !!variant.options_with_values.find(x => x.name === "Color");
        const valuesOption = variant.options_with_values.find(x => String(x.name).toLowerCase() === "values");
        const amountValue = valuesOption ? valuesOption.value : null;

        items.push({
          id: variant.id,
          key: variant.key,
          vendor: variant.vendor,
          title: variant.product_title,
          desc: variant.product_description,
          handle: variant.handle,
          variant_title: variant.variant_title,
          // One Tree Planted is added as a gift and has no product page to link to
          url: variant.product_title === "One Tree Planted" ? '' : (variant.url || ''),
          qty: variant.quantity,
          price: removeTrailingZeros(Shopify.formatMoney(price_qty, moneyFormat)),
          compare: cartCompareAtPrice(variant),
          //compare: removeTrailingZeros(Shopify.formatMoney(comparePrice, moneyFormat)),
          //onSale: onSale,
          image: imgSmall,
          options: variant.options_with_values,
          optionLabel: option_label,
          size: sizeValue,
          amount: amountValue,
          showColor: showColor,
          errorClass: errorClass,
          error: liquidVars.cartError,
          prompt: liquidVars.cartErrorPrompt,
          remove: liquidVars.removeItem
        });
      }

       Utilities.gamification();
      if (nonTreeItemCount > 0) $('#CartTrigger').addClass('has-items');
      $('.CartCount').text(nonTreeItemCount);
      $('.CartCount').attr('data-cart-count', nonTreeItemCount);
      return items;
    },

    renderCartPage: async function (cart) {
      Utilities.updateCartJson(cart);
      var source = $("#cart-page-template").html(),
        template = Handlebars.compile(source);            
      const { total_price } = cart;
      const bodyContent = document.querySelector("body");
      const freeGift = bodyContent.getAttribute("product-gift-handle");
      const freeGiftMen = bodyContent.getAttribute("product-gift-handle-men");
      const priceGamification = bodyContent.getAttribute("data-gamification");
      const quantity = bodyContent.getAttribute("data-gamification-quantity");
      const collection = bodyContent.getAttribute("data-gamification-collection");
      const collectionsInfo = await Utilities.getCollectionsFromCartProducts(cart.items, collection);
      const itemsQuantity = collectionsInfo.topCollectionCount;

      if (total_price < priceGamification || itemsQuantity < quantity) {
        setTimeout(() => {
          if (freeGift) {
            const freeGiftBtnEl = document.querySelector(`.product-${freeGift} .cart-remove-btn`);
            if (freeGiftBtnEl) freeGiftBtnEl.click();
          }
        }, 1000)

        setTimeout(() => {
          if (freeGiftMen) {
            const freeGiftMenBtnEl = document.querySelector(`.product-${freeGiftMen} .cart-remove-btn`);
            if (freeGiftMenBtnEl) freeGiftMenBtnEl.click();
          }
        }, 1100)
      }

      cart.item_count === 0
        ? $('#cart-page').addClass('empty')
        : $('.cart-page').removeClass('empty');
      $('.subtotal-price .cart-total-prices').html(cartTotalPricesHtml(cart));
      const cartBody = document.querySelector('.cart-body');
      const savedFocus = captureCartFocus(cartBody);
      $('.cart-body').html(template({ items: Utilities.setCartData(cart) }));
      restoreCartFocus(cartBody, savedFocus, cartPageFocusFallback);
      if($('input[data-handle="one-tree-planted"]').length > 0) {
        $('input[data-handle="one-tree-planted"]').attr('disabled', 'disabled');
      }

      cart.items.map( item => {
        const colorValue = item.options_with_values.find(x => x.name === "Color");
        if (colorValue) {
          const color = Utilities.getColorNameByCode(colorValue.value);
          if (color && document.querySelector(`.item-cart-page-${item.handle} .colorNameCart`)) {
            document.querySelector(`.item-cart-page-${item.handle} .colorNameCart`).innerHTML = `Color: <span style="text-transform: uppercase">${color}</span>`
          }

        }
      });
    },

    renderCartFlyout: function (cart, openFlyout) {
      const {
        item_count
      } = cart;

      Utilities.updateCartJson(cart);
      var source = $('#cart-template').html(),
        template = Handlebars.compile(source);

      if(document.querySelector('#progress-bar')){
        if (item_count > 0) {
          document.querySelector('#progress-bar').classList.add('show');
        } else {
          document.querySelector('#progress-bar').classList.remove('show');
        }
      }

      item_count === 0
        ? Lemonade.cache.$cartFlyout.addClass('empty')
        : Lemonade.cache.$cartFlyout.removeClass('empty');

      const products = Lemonade.cache.$cartFlyoutProducts[0];
      const savedFocus = captureCartFocus(products);

      const itemsToChange = Utilities.setCartData(cart);
      Lemonade.cache.$cartFlyoutProducts.html(template({ items: itemsToChange }));

      const sortedItems = itemsToChange.sort((a, b) => {
        const isAOneTree = a.handle === 'one-tree-planted';
        const isBOneTree = b.handle === 'one-tree-planted';
        if (isAOneTree && !isBOneTree) return 1;
        if (!isAOneTree && isBOneTree) return -1;
        return 0;
      });

      Lemonade.cache.$cartFlyoutProducts.html(template({ items: sortedItems }));
      restoreCartFocus(products, savedFocus, function () { return document.getElementById('CloseFlyout'); });

      if ($('input[data-handle="one-tree-planted"]').length > 0) {
        $('input[data-handle="one-tree-planted"]').attr('disabled', 'disabled');
      }

      var totalCurrency = document.querySelector("#Subtotal");
      if (totalCurrency) {
        totalCurrency.innerHTML = Utilities.cartTotalHtml(cart);
      }

      if (openFlyout) {
        Utilities.openCartFlyout();
      }
    },

    resizeCartFlyout: function () {
      var theCartSize = (Lemonade.cache.$win.outerHeight() - ($('.flyout-header').outerHeight() + $('#CartFlyoutSummary').outerHeight()));

      if (isMobile) {
        theCartSize = ((Lemonade.cache.$win.outerHeight() + 1000) - ($('.flyout-header').outerHeight() + $('#CartFlyoutSummary').outerHeight()));
      }

      Lemonade.cache.$cartFlyoutProducts.css({
        maxHeight: theCartSize
      });
    },

    oneTreeProductAdd: function () {
      Utilities.addProductToCart({ id: parseInt(liquidVars.oneTreeProdID), quantity: 1 }, false, false, 'pdp');
    }

  }

})();


// Global selectors and values
Lemonade.cacheSelectors = function () {

  Lemonade.cache = {

    // General
    $win: $(window),
    $body: $('body'),

    // Header & Nav
    header: document.getElementById('AppHeader'),
    $header: $('#AppHeader'),

    // Cart
    $cartCount: $('.CartCount'),
    $cartFlyout: $('#CartFlyout'),
    $cartFlyoutProducts: $('#CartFlyoutProducts'),
    $cartSavedReturn: $('.cart-saved-container')

  };

};

// Kick off functions
// Dot strips are a tablist: one tab stop on the active dot, arrows move between them.
// Handled generically off the DOM so every slider in the theme gets it, whichever
// library drew the dots and whenever it happens to initialise.
Lemonade.sliderPaginationA11y = function () {
  const STRIPS = '.swiper-pagination, .slick-dots';
  const SEEN = 'lvDots';

  function dotsOf(strip) {
    const sel = strip.classList.contains('slick-dots') ? 'li > button' : '.swiper-pagination-bullet';
    return Array.prototype.filter.call(strip.querySelectorAll(sel), function (el) {
      return el.getClientRects().length > 0;
    });
  }

  function activeIndex(dots) {
    for (let i = 0; i < dots.length; i++) {
      const dot = dots[i];
      if (dot.classList.contains('swiper-pagination-bullet-active')) return i;
      if (dot.parentElement && dot.parentElement.classList.contains('slick-active')) return i;
    }
    return 0;
  }

  function sync(strip) {
    const dots = dotsOf(strip);
    if (!dots.length) return;
    const active = activeIndex(dots);
    if (strip.getAttribute('role') !== 'tablist') strip.setAttribute('role', 'tablist');
    dots.forEach(function (dot, i) {
      if (dot.getAttribute('role') !== 'tab') dot.setAttribute('role', 'tab');
      dot.setAttribute('aria-selected', i === active ? 'true' : 'false');
      dot.setAttribute('tabindex', i === active ? '0' : '-1');
      if (!dot.getAttribute('aria-label')) dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
    });
  }

  function adopt(strip) {
    if (strip.dataset[SEEN] || strip.dataset.keyboardReady) return;
    strip.dataset[SEEN] = 'true';
    // slick re-applies tabindex to its slides on every change, and that change also
    // rewrites the active class in here - so one observer covers both
    const slider = strip.closest('.slick-slider');
    sync(strip);
    if (slider) demoteSlides(slider);
    new MutationObserver(function () {
      sync(strip);
      if (slider) demoteSlides(slider);
    }).observe(strip, { subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  // slick marks each slide role=tabpanel tabindex=0. The slide is not a link and its
  // own controls are reachable on their own, so that stop leads nowhere.
  function demoteSlides(root) {
    if (root.matches && root.matches('.slick-slide[role="tabpanel"]') && root.getAttribute('tabindex') !== '-1') {
      root.setAttribute('tabindex', '-1');
    }
    root.querySelectorAll('.slick-slide[role="tabpanel"]').forEach(function (slide) {
      if (slide.getAttribute('tabindex') !== '-1') slide.setAttribute('tabindex', '-1');
    });
  }

  function scanRoot(root) {
    if (root.matches && root.matches(STRIPS)) adopt(root);
    root.querySelectorAll(STRIPS).forEach(adopt);
    demoteSlides(root);
  }

  document.addEventListener('keydown', function (e) {
    const strip = e.target.closest && e.target.closest(STRIPS);
    if (!strip || strip.dataset.keyboardReady) return;
    const dots = dotsOf(strip);
    const current = dots.indexOf(e.target);
    if (current === -1 || dots.length < 2) return;

    let next = -1;
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (current + 1) % dots.length;
    else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (current - 1 + dots.length) % dots.length;
    else if (e.key === 'Home') next = 0;
    else if (e.key === 'End') next = dots.length - 1;
    else return;

    e.preventDefault();
    if (!dots[next]) return;
    dots[next].click();
    // the click re-renders the strip, so re-read it before focusing
    const after = dotsOf(strip)[next];
    if (!after) return;
    after.setAttribute('tabindex', '0');
    after.focus();
  });

  // apps and grid hydration insert nodes continuously, so only look inside what was added
  let pending = [];
  let queued = false;
  new MutationObserver(function (records) {
    for (let i = 0; i < records.length; i++) {
      const added = records[i].addedNodes;
      for (let j = 0; j < added.length; j++) {
        if (added[j].nodeType === 1) pending.push(added[j]);
      }
    }
    if (!pending.length || queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      const roots = pending;
      pending = [];
      roots.forEach(function (root) {
        if (root.isConnected) scanRoot(root);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  scanRoot(document.documentElement);
};

// Klaviyo hides its consent radio in a clipped 1x1 input, so Enter reached the form's implicit submit instead of it
Lemonade.klaviyoConsentKeys = function () {
  const CONSENT = 'input.klaviyo-sr-only[type="radio"], input.klaviyo-sr-only[type="checkbox"]';

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    const input = e.target;
    if (!input || !input.matches || !input.matches(CONSENT)) return;
    // once it is ticked there is nothing left to toggle, so Enter goes back to submitting
    if (input.checked) return;
    e.preventDefault();
    // click, not .checked, so klaviyo's own validation sees the change and clears its error
    input.click();
  });
};

Lemonade.init = function () {
  Lemonade.cacheSelectors();
  Lemonade.sliderPaginationA11y();
  Lemonade.klaviyoConsentKeys();
  Lemonade.windowState();
  Lemonade.lazyLoad();
  Lemonade.inView();
  Lemonade.appHeader();
  Lemonade.accordion($('.AccTrigger'), $('.AccContent'));
  Lemonade.slick();
  Lemonade.productQuantity();
  Lemonade.initCartFlyout();
  Lemonade.cartPage();
  Lemonade.labels();
  Lemonade.quickShopAndImageSwap();
  Lemonade.autoResponsiveElements();
  Lemonade.filtering();
  $(window).on('load', function () {
    Lemonade.fitVids();
    Lemonade.sticky();
  });
  Lemonade.videoPlayer();
  Lemonade.sizeGuide();
  Lemonade.pageAccordions();

  if (bodyClasses.contains('collection')) {
    Lemonade.collectionPage();
  }
  if (bodyClasses.contains('page')) {
    Lemonade.collectionPageGift();
  }
  if (bodyClasses.contains('product')) {
    Lemonade.productPage();
  }

};

// Determine if window width is Desktop, Tablet or Mobile
Lemonade.windowState = function () {
  var win_width,
    state;

  // Check state of window width (wide vs narrow screen)
  var winState = function () {
    win_width = Lemonade.cache.$win.width();
    if (win_width > 1023) {
      if (state != 'max') {
        state = 'max';
        changedstate(state);
      };
    } else if (win_width > 767 && win_width <= 1023) {
      if (state != 'desktop') {
        state = 'desktop';
        changedstate(state);
      };
    } else {
      if (state != 'mobile') {
        state = 'mobile';
        changedstate(state);
      };
    }
  };

  // If/When window crosses the wide/narrow threshold you can do some stuff here
  function changedstate(mystate) {
    Lemonade.scrollYes();
    Lemonade.cache.$header.removeClass('MenuOpen');
    if (mystate == 'max') {
      Lemonade.cache.$body
        .removeClass('NarrowScreen WideScreen')
        .addClass('MaxScreen');
    } else if (mystate == 'desktop') {
      // Do wide screen stuff here
      Lemonade.cache.$body
        .removeClass('NarrowScreen MaxScreen NoScroll')
        .addClass('WideScreen');
    } else {
      // Do narrow screen stuff here
      Lemonade.cache.$body
        .removeClass('WideScreen MaxScreen')
        .addClass('NarrowScreen');
      $('.btn-addtocart').hide();
    }
  }

  winState();

  Lemonade.cache.$win.on({
    resize: function () {
      winState();
    }
  });
}

// Lazy Load library dependancy http://jquery.eisbehr.de/lazy
// Dynamically load images
Lemonade.lazyLoad = function () {
  $('.Lazy').Lazy({
    effect: 'fadeIn',
    visibilityOnly: true,
    onError: function (element) {
      console.log('error loading ' + element.data('src'));
    }
  });
};

// Inview library dependancy https://github.com/protonet/jquery.inview
Lemonade.inView = function () {
  $('.AnimateIn').one('inview', function (event, isInView) {
    if (isInView) {
      $(this).addClass('InView');
      if ($(this).hasClass('item-product')) {
        if ($(this).find('.quickshop-wrap .swatchTrigger').length < 1) {
          $(this).find('.item-detail-swatches').hide();
        }
      }
    } else {
      $(this).removeClass('InView');
    }
  });
};

// Wrap Iframes in Markup in preperation for FitVids
Lemonade.autoResponsiveElements = function () {
  if (window.location.pathname != "/pages/product" || window.location.pathname != "/pages/progress") {
    var $iframeVideo = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]'),
      $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

    $iframeVideo.each(function () {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="video-wrapper"></div>');
    });

    $iframeReset.each(function () {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }

};

// Fit Vids library dependancy (responsive iframes)
Lemonade.fitVids = function () {
  Lemonade.cache.$body.find('.video-wrapper').fitVids();
};

// Return window scrollTop
Lemonade.windowScrollTop = function () {
  return $(window).scrollTop();
};

Lemonade.scrollPosition = 0;
Lemonade.cartScrollPosition = 0;
Lemonade.isRestoringScroll = false;

// Body no scroll
Lemonade.scrollYes = function () {
  Lemonade.cache.$body.removeClass('NoScroll');
};

// Body yes scroll
Lemonade.scrollNo = function () {
  Lemonade.cache.$body.addClass('NoScroll');
};

// Site Header and Nav
Lemonade.appHeader = function () {

  var $navLink = $('.NavLink'),
    $dropdown = $('.MenuDropdown'),
    $hamburger = $('#Hamburger'),
    $mobileMenu = $('#AppNavMobile'),
    dropdownTimer = null,
    winPos;

  function closeDropdown() {
    Lemonade.cache.$header.removeClass('Open');
    $navLink.attr('aria-expanded', 'false').removeClass('Active');
    $dropdown.removeClass('Show').attr('aria-hidden', 'true');

  }

  function openDropdown(el) {
    clearTimeout(dropdownTimer);
    var meDataMenu = el.attr('data-dropdown'),
      meMenu = $('#' + meDataMenu);
    // closeDropdown resets every trigger, so claim the expanded state after it
    closeDropdown();
    el.attr('aria-expanded', 'true');
    Lemonade.cache.$header.addClass('Open');
    el.addClass('Active');
    meMenu.addClass('Show').attr('aria-hidden', 'false');
  }

  function appSearch() {
    var $utilitiesUL = $('#app-utilities ul'),
      $searchTrigger = $('#SearchTrigger'),
      $searchForm = $('#AppSearch');

    $searchTrigger.on('click', function () {
      $searchTrigger.addClass('Active').attr('aria-expanded', 'true');
      $searchForm.addClass('Show').attr('aria-hidden', 'false');
      Lemonade.cache.$header.addClass('SearchActive');
      $utilitiesUL.addClass('Hide');
    });

    $('#CloseSearch').on('click', function () {
      $searchTrigger.removeClass('Active').attr('aria-expanded', 'false');
      $searchForm.removeClass('Show').attr('aria-hidden', 'true');
      Lemonade.cache.$header.removeClass('SearchActive');
      setTimeout(function () {
        $utilitiesUL.removeClass('Hide');
      }, 300);
    });

  }

  function toggleMobileMenu() {
    if ($hamburger.hasClass('Open')) {
      closeMobileMenu();
    } else {
      Lemonade.scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      
      AppHeader.classList.add('MenuOpen');
      $hamburger.addClass('Open').attr('aria-expanded', 'true');
      $mobileMenu.addClass('ShowMenu').attr('aria-hidden', 'false');
      Lemonade.scrollNo();
      
      Lemonade.cache.$body.css({
        'position': 'fixed',
        'top': `-${Lemonade.scrollPosition}px`,
        'width': '100%'
      });
    }
  }

  function closeMobileMenu() {
    AppHeader.classList.remove('MenuOpen');
    $mobileMenu.removeClass('ShowMenu').attr('aria-hidden', 'true');
    $hamburger.removeClass('Open').attr('aria-expanded', 'false');
    $('.MenuPanel').removeClass('Show').attr('aria-hidden', 'true');
    $('.HasPanel').attr('aria-expanded', 'false');
    Lemonade.scrollYes();
    
    const headerFlex = document.getElementById('header-flex');
    if (headerFlex) {
      headerFlex.classList.remove('hidden');
    }
    
    Lemonade.cache.$body.css({
      'position': '',
      'top': '',
      'width': ''
    });
    
    Lemonade.isRestoringScroll = true;
    window.scrollTo(0, Lemonade.scrollPosition);
    
    setTimeout(function() {
      Lemonade.isRestoringScroll = false;
    }, 100);
  }

  function checkHeaderScrolled() {
    winPos = Lemonade.cache.$win.scrollTop();
    if (winPos > 50) {
      Lemonade.cache.header.classList.add('Scrolled');
    } else {
      Lemonade.cache.header.classList.remove('Scrolled');
    }
  }

  $navLink.on({
    click: function () {
      var $me = $(this);
      if ($me.hasClass('Active')) {
        closeDropdown();
      } else {
        openDropdown($me);
      }
    },
    mouseenter: function () {
      var $me = $(this);
      if ($me.hasClass('HasDropdown')) {
        openDropdown($me);
      }
    },
    mouseleave: function () {
      dropdownTimer = setTimeout(function () {
        closeDropdown();
      }, 100);
    }
  });

  $dropdown.on({
    mouseenter: function () {
      clearTimeout(dropdownTimer);
    },
    mouseleave: function () {
      closeDropdown();
    }
  })

  // Enter has to stay navigation on a real link, so the panel opens on Down Arrow or Space
  $navLink.on('keydown', function (e) {
    const $me = $(this);

    if (e.key === 'Escape' || e.key === 'Esc') {
      if ($me.hasClass('Active')) {
        e.preventDefault();
        closeDropdown();
      }
      return;
    }

    if (!$me.hasClass('HasDropdown')) return;
    if (e.key !== 'ArrowDown' && e.key !== 'Down' && e.key !== ' ' && e.key !== 'Spacebar') return;

    e.preventDefault();
    openDropdown($me);

    const panel = document.getElementById($me.attr('data-dropdown'));
    const first = panel && panel.querySelector('a[href]');
    if (!first) return;

    // the panel fades in from visibility:hidden, so focus only lands once it paints
    let tries = 0;
    (function focusPanel() {
      first.focus();
      if (document.activeElement === first || tries > 10) return;
      tries++;
      requestAnimationFrame(focusPanel);
    })();
  });

  $dropdown.on('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    const trigger = document.querySelector('.NavLink[data-dropdown="' + this.id + '"]');
    e.preventDefault();
    closeDropdown();
    if (trigger) trigger.focus();
  });

  // tabbing off the panel onto another top-level item has to collapse it
  $('#AppNav').on('focusin', function (e) {
    const openTrigger = this.querySelector('.NavLink.Active');
    if (!openTrigger || e.target === openTrigger) return;
    const panel = document.getElementById(openTrigger.getAttribute('data-dropdown'));
    if (panel && panel.contains(e.target)) return;
    closeDropdown();
  });

  $('#AppNav').on('focusout', function () {
    const nav = this;
    setTimeout(function () {
      if (!nav.contains(document.activeElement)) closeDropdown();
    }, 0);
  });

  $hamburger.on('click', toggleMobileMenu);

  Lemonade.cache.$win.scroll(checkHeaderScrolled);

  $('.HasPanel').on('click', function (e) {
    e.preventDefault();
    var $me = $(this),
      me_data = $me.attr('data-panel'),
      $mePanel = $(me_data);

    $me.attr('aria-expanded', 'true');
    $mePanel.addClass('Show').attr('aria-hidden', 'false').siblings().removeClass('Show');
  });

  $('.back-btn button').on('click', function (e) {
    e.preventDefault();
    $(this).closest('.MenuPanel').removeClass('Show').attr('aria-hidden', 'true').prev('.HasPanel').attr('aria-expanded', 'false');
  })

  checkHeaderScrolled();
  appSearch();
};

// Content accordions
Lemonade.accordion = function (trigger, content) {
  var $accTrigger = trigger;
  if ($('.product-accordions').length) {
    $('.product-accordions .accordion').each(function(index, el) {
      if (index === 0 && window.innerWidth > 767) {
        $(el).find('.AccTrigger').addClass('Open').attr('aria-expanded', 'true');
        $(el).find('.AccContent').slideDown();
      }
    });
  }
  // accordian content
  $accTrigger.click(function (e) {
    e.preventDefault();
    var $me = $(this),
      $content = $me.next('.AccContent');

    if ($me.hasClass('Open')) {
      $me.removeClass('Open').attr('aria-expanded', 'false');
    } else {
      $me.addClass('Open').attr('aria-expanded', 'true');
    }

    if ($me.hasClass('Open')) {
      $content.slideDown().attr('aria-hidden', 'false');
    } else {
      $content.slideUp().attr('aria-hidden', 'true');
    }
  });

  // real <button> triggers already activate on Enter/Space natively
  $accTrigger.on('keydown', function (e) {
    if (this.tagName === 'BUTTON') return;
    if (e.key !== 'Enter' && e.key !== ' ' && e.keyCode !== 13 && e.keyCode !== 32) return;
    e.preventDefault();
    $(this).trigger('click');
  });
};

// Library dependancy https://github.com/kenwheeler/slick/
// Slick Slideshow init
Lemonade.slick = function () {

  // without this a missing slick.min.js throws here and kills the rest of Lemonade.init
  if (!$.fn.slick) return;

  var $slick = $('.Slick'),
    $productImages = $('.ProductSlick'),
    $mobileSlick = $('.MobileSlick');

  $slick.slick({
    lazyLoad: 'progressive'
  });

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    $slick.filter('.slick-initialized').slick('slickPause');
  }

  Lemonade.cache.$win.on({
    load: function () {
      if (Lemonade.cache.$body.hasClass('MaxScreen') || Lemonade.cache.$body.hasClass('WideScreen')) {
        if ($mobileSlick.hasClass('slick-initialized')) {
          $mobileSlick.slick('unslick');
        }
      } else {
        if (!$mobileSlick.hasClass('slick-initialized')) {
          $mobileSlick.slick({
            lazyLoad: 'progressive'
          });
        }
      }
    },
    resize: function () {
      if (Lemonade.cache.$body.hasClass('MaxScreen') || Lemonade.cache.$body.hasClass('WideScreen')) {
        if ($productImages.hasClass('slick-initialized')) {
          $productImages.slick('unslick');
        }
        if ($mobileSlick.hasClass('slick-initialized')) {
          $mobileSlick.slick('unslick');
        }
      } else {
        if (!$productImages.hasClass('slick-initialized')) {
          $productImages.slick({
            lazyLoad: 'progressive'
          });
        }
        if (!$mobileSlick.hasClass('slick-initialized')) {
          $mobileSlick.slick({
            lazyLoad: 'progressive'
          });
        }
      }
    }
  });
};

// PDP sticky sidebar
Lemonade.sticky = function () {
  if (!Lemonade.cache.$body.hasClass('NarrowScreen')) {
    stickyKit();
  }
  Lemonade.cache.$win.on({
    resize: function () {
      if (!Lemonade.cache.$body.hasClass('NarrowScreen')) {
        stickyKit();
      } else {
        //detachStickyKit();
      }
    }
  });

  // function detachStickyKit() {
  //   $("#ProductDetails").trigger("sticky_kit:detach");
  // }

  function stickyKit() {
    // $("#ProductDetails").stick_in_parent({
    //   offset_top: 0,
    //   parent: '#ProductUpper'
    // });
  }
}

// Custom product quantity
Lemonade.productQuantity = function () {

  $(".Qty").find('span').on("click keydown", function (e) {
    if (e.type === "keydown") {
      if (e.which !== 13 && e.which !== 32) return;
      e.preventDefault();
    }
    var $button = $(this);
    // aria-disabled, unlike a real disabled attribute, does not stop the event
    if ($button.attr('aria-disabled') === 'true') return;
    var qtyInput = $button.closest('.Qty').find('.Quantity');
    var oldValue = qtyInput.val();
    var minusBtn = $button.hasClass('down') ? $button : $button.siblings('.down');

    if ($button.hasClass('up')) {
      var newVal = parseFloat(oldValue) + 1;
    } else {
      // Don't allow decrementing below one
      if (oldValue > 0) {
        var newVal = parseFloat(oldValue) - 1;
      } else {
        newVal = 0;
      }
    }

    if (newVal <= 1 && minusBtn) {
      minusBtn.attr('aria-disabled', 'true').addClass('_disabled');
    } else if (minusBtn) {
      minusBtn.removeAttr('aria-disabled').removeClass('_disabled');
    }
    qtyInput.val(newVal);
  });
};

// Product Variant Change
// Single shared, memoized fetch of all Storefront variants (per product handle).
// Reused by changeVariant and customSelectsUI so the full variant list is fetched
// ONCE per page instead of on every colour/size click — re-fetching on each click
// made the Add-to-Cart / Notify button lag 1-2s behind the selection. Requests the
// superset of fields all callers need.
Lemonade.getAllVariants = function (handle) {
  window.__allVariantsPromise = window.__allVariantsPromise || {};
  if (!handle) return Promise.resolve([]);
  if (!window.__allVariantsPromise[handle]) {
    var STOREFRONT_TOKEN = ((window.LIVE && window.LIVE.storefrontToken) || 'ed761c0d0f68bc596e5e4dd4e29e6407');
    var SHOP_DOMAIN = ((window.LIVE && window.LIVE.shopDomain) || 'live-ecom.myshopify.com');
    window.__allVariantsPromise[handle] = (async function () {
      var all = [];
      var cursor = null;
      var hasNext = true;
      while (hasNext) {
        var query = `
          query ($handle: String!, $cursor: String) {
            product(handle: $handle) {
              variants(first: 250, after: $cursor) {
                edges {
                  cursor
                  node {
                    id
                    sku
                    quantityAvailable
                    availableForSale
                    selectedOptions { name value }
                    price { amount currencyCode }
                    compareAtPrice { amount currencyCode }
                    metafield(namespace: "custom", key: "active") { value type }
                  }
                }
                pageInfo { hasNextPage }
              }
            }
          }
        `;
        var res = await fetch(`https://${SHOP_DOMAIN}/api/2025-07/graphql.json`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
          },
          body: JSON.stringify({ query: query, variables: { handle: handle, cursor: cursor } })
        });
        var json = await res.json();
        if (!json || !json.data || !json.data.product) break;
        var variants = json.data.product.variants;
        variants.edges.forEach(function (edge) {
          all.push(edge.node);
          cursor = edge.cursor;
        });
        hasNext = variants.pageInfo.hasNextPage;
      }
      return all;
    })();
    window.__allVariantsPromise[handle].catch(function () {
      delete window.__allVariantsPromise[handle];
    });
  }
  return window.__allVariantsPromise[handle];
};

Lemonade.changeVariant = function (options) {
  const productVariantsRoot = document.querySelector('.product-variants');
  const handle = productVariantsRoot?.dataset.handle;
  const isBackInStockEnabled = productVariantsRoot?.dataset.backInStockEnabled === 'true';
  const allVariants = Lemonade.getAllVariants(handle);
  var currentColorSelected = '';
  var currentSizeSelected = '';
  var currentValueSelected = '';

  var $root = productVariantsRoot ? $(productVariantsRoot) : $('.product-variants').first();

  $root.find('.selector-wrapper.size').find('.selector-options div').each(function (i, el) {
    var me = $(el);
    if (me.hasClass('Active')){
      currentSizeSelected = me.data('val');
    }
  });
  $root.find('.selector-wrapper.color').find('.selector-options div').each(function (i, el) {
    var me = $(el);
    if (me.hasClass('Active')){
      currentColorSelected = me.data('val');
    }
  });
  $root.find('.selector-wrapper.values').find('.selector-options div').each(function (i, el) {
    var me = $(el);
    if (me.hasClass('Active')){
      currentValueSelected = me.data('val');
    }
  });


  $root.find('.product-single__variants option').each(function () {
    const $option = $(this);
    if (this.selected) {
      this.selected = false;
    }
    
    if ($option.data('color') === currentColorSelected && ($option.data('size') === currentSizeSelected || $option.data('value') === currentValueSelected)) {        
      this.selected = true;
    }
  });

  allVariants.then(function (variants2) {
    const onlyVariants = variants2.flat();
    var moneyFormat = options.money_format,
      variant = options.variant,
      translations = options.translations;

    function normalizeOptionValue(value) {
      if (value == null) return '';
      return String(value).trim().toLowerCase();
    }

    function isVariantActive(variantItem) {
      var activityValue = variantItem?.metafield?.value;
      return activityValue == null || String(activityValue).toLowerCase() !== 'false';
    }

    if (options.sizesLength == 1) {
      sizeSelected = true;
    }

    var $addToCart = $('#AddToCart'),
      $comparePrice = $('#ComparePrice'),
      $quantityElements = $('.ProductQty'),
      $addToCartText = $('#AddToCartText');

    if (currentSelected2 == null) {
      currentSelected2 = options.first_color;
    }

    function updateSalePriceColorState(selectedVariant) {
      const priceContainers = document.querySelectorAll('#ProductDetails .product__price[data-sale-price-color]');
      if (!priceContainers.length) {
        return;
      }

      const selectedPrice = Number(selectedVariant && selectedVariant.price);
      const selectedCompareAt = Number(selectedVariant && selectedVariant.compare_at_price);
      const hasDiscount = Number.isFinite(selectedPrice) && Number.isFinite(selectedCompareAt) && selectedCompareAt > selectedPrice;

      priceContainers.forEach((container) => {
        const configuredColor = (container.dataset.salePriceColor || '').trim();

        if (hasDiscount && configuredColor) {
          container.style.setProperty('--sale-price-color', configuredColor);
          return;
        }

        container.style.removeProperty('--sale-price-color');
      });
    }

    function inventoryStatus(isAvailable, me) {
      if (!isAvailable) {
        me.addClass('soldout');
        if (isBackInStockEnabled) {
          return;
        }
        // if the current selected color is not available in the newly selected size trigger a click on the first available color in that size
        if (me.hasClass('Active')) {
          setTimeout(function () {
            $root.find('.selector-wrapper.size').find('.selector-options div:not(.soldout)').first().trigger('click');
          }, 200);
        }
      } else {
        me.removeClass('soldout');
      }
    }

    var $lbColorNow = $root.find('.selector-wrapper.color .selector-options div.Active').last();
    if ($lbColorNow.length) currentColorSelected = $lbColorNow.data('val');
    var $lbSizeNow = $root.find('.selector-wrapper.size .selector-options div.Active').last();
    if ($lbSizeNow.length) currentSizeSelected = $lbSizeNow.data('val');

    $root.find('.selector-wrapper.size').find('.selector-options div').each(function (i, el) {
      var $me = $(el),
        me_val = $me.data('val');

      if ($me.hasClass('Active')){
        const activeVariant = onlyVariants.find(variant => {
          const color = variant.selectedOptions.find(o => o.name === 'Color')?.value;
          const size  = variant.selectedOptions.find(o => o.name === 'Size')?.value;
          const value = variant.selectedOptions.find(o => o.name === 'Values')?.value;
          return normalizeOptionValue(color) === normalizeOptionValue(currentColorSelected)
            && normalizeOptionValue(size) === normalizeOptionValue(currentSizeSelected)
            && (
              !currentValueSelected
              || normalizeOptionValue(value) === normalizeOptionValue(currentValueSelected)
            );
        });

        if (activeVariant){
          variant = activeVariant;
        }
      }

      // Assume no variant exists for this color+size until proven otherwise
      var matchFound = false;

      const matchingVariants = onlyVariants.filter(variant => {
        const variantColor = variant.selectedOptions.find(o => o.name === 'Color')?.value;
        const variantSize  = variant.selectedOptions.find(o => o.name === 'Size')?.value;
        const colorMatches = variantColor ? normalizeOptionValue(variantColor) === normalizeOptionValue(currentColorSelected) : true;

        return colorMatches && normalizeOptionValue(variantSize) === normalizeOptionValue(me_val);
      });

      matchFound = matchingVariants.length > 0;

      if (matchFound) {
        const hasAvailableVariant = matchingVariants.some(variant => {
          return variant.availableForSale && isVariantActive(variant);
        });

        inventoryStatus(hasAvailableVariant, $me);
      }

      // Size does not exist at all for the selected color — mark soldout.
      // (Auto-selecting a valid size is handled once, after this loop, by the
      // "ensure a valid size stays selected" step below — proximity-aware and
      // independent of the back-in-stock/notify setting.)
      if (!matchFound) {
        $me.addClass('soldout');
      }
    });

    // If the size that was selected no longer exists for the newly chosen color
    // (its swatch was hidden by updateSizeVisibility → `variant-not-existing`),
    // the shopper is left with an invalid selection and a stuck button. Auto-pick
    // a valid size: the nearest IN-STOCK size to the previous choice, or — if none
    // are in stock — the first size that exists for this color (so a size stays
    // selected and Notify reflects it). Only runs when a size WAS selected, so the
    // initial "select a size" state is left untouched.
    var $lbSizeSwatches = $root.find('.selector-wrapper.size .selector-options > div');
    var $lbActiveSize = $lbSizeSwatches.filter('.Active').first();
    if ($lbActiveSize.length && $lbActiveSize.hasClass('variant-not-existing')) {
      var lbSizeEls = $lbSizeSwatches.toArray();
      var lbRefIdx = lbSizeEls.indexOf($lbActiveSize.get(0));
      var lbExisting = lbSizeEls.filter(function (el) {
        return !el.classList.contains('variant-not-existing');
      });
      if (lbExisting.length) {
        var lbPickNearest = function (pool) {
          var best = null, bestDist = Infinity;
          pool.forEach(function (el) {
            var d = lbRefIdx >= 0 ? Math.abs(lbSizeEls.indexOf(el) - lbRefIdx) : lbSizeEls.indexOf(el);
            if (d < bestDist) { bestDist = d; best = el; }
          });
          return best;
        };
        var lbInStock = lbExisting.filter(function (el) { return !el.classList.contains('soldout'); });
        var lbTarget = lbInStock.length ? lbPickNearest(lbInStock) : lbExisting[0];
        if (lbTarget) {
          $(lbTarget).trigger('click');
          return; // the click re-runs changeVariant with a valid size selected
        }
      }
    }

    if (variant) {
      // Shape-aware availability for the current selection. `variant` is either
      // the ProductOptionSelectors variant (has .available) or, when a matching Storefront
      // node was found above, that node (has .availableForSale + the custom
      // "active" metafield). Normalise to ONE boolean so switching between a
      // sold-out and an in-stock variant always toggles the button correctly
      // (previously the else-branch used .available on a Storefront-shaped object,
      // leaving the button stuck on "Sold Out — Notify Me").
      var effectiveAvailable = (typeof variant.availableForSale !== 'undefined')
        ? (variant.availableForSale && isVariantActive(variant))
        : (variant.available === true);

      // Select a valid variant if available
      currentAvailable = effectiveAvailable;
      currentComparePrice = null;
      if (variant.sku) {
        $('.product-sku span').text(variant.sku);
        $(".sticky-product-sku").text(`SKU: ${variant.sku}`);
        $('.accordion-sku').show();
      } else {
        $('.product-sku').hide();
        $(".sticky-product-sku").hide();
        $('.accordion-sku').hide();
      }
      if (effectiveAvailable) {
        // Available, enable the submit button, change text, show quantity elements
        const variantPrice = Shopify.formatMoney(variant.price, moneyFormat);

        var priceMarkup = `${translations.add_to_bag}`;
        if (variant.compare_at_price != null) {
          const variantCompareAtPrice = Shopify.formatMoney(variant.compare_at_price, moneyFormat)
          priceMarkup = `${translations.add_to_bag}`;
          if (variant.compare_at_price) {
            currentComparePrice = variantCompareAtPrice;
          }
        }
        currentPrice = variantPrice;
        if (sizeSelected) {
          $addToCart.removeClass('disabled').prop('disabled', false);
          $addToCartText.html(priceMarkup);
        } else if (options.has_size_option) {
          $addToCartText.html('select a size');
        } else {
          $addToCartText.html(priceMarkup);
        }
        $quantityElements.show();
       
        const $notifyBtn = document.querySelector('.custom-notify-button');
        if ($notifyBtn) {
          $notifyBtn.classList.remove('_active');
          $notifyBtn.style.display = 'none';
        }
        const $notifyForm = document.querySelector('.custom-notify-form');
        if ($notifyForm) {
          // Fully reset the notify form. Its ._active / .success states use
          // `display: block !important` (custom.css), so without clearing the
          // classes the form would stay visible over the restored Add to Cart
          // button when returning to an in-stock variant.
          $notifyForm.classList.remove('_active', 'success');
          $notifyForm.style.display = 'none';
        }
        $addToCart[0].style.removeProperty('display');
      } else {
        // Out of stock (or inactive): hide add to cart, show notify button.
        // Only once a size is chosen (or there is no size option) so we don't
        // show Notify before the shopper has picked a size.
        if (!options.has_size_option || sizeSelected) {
          const $notifyBtn = document.querySelector('.custom-notify-button');
          if ($notifyBtn) $notifyBtn.style.display = '';
          const $notifyForm = document.querySelector('.custom-notify-form');
          if ($notifyForm) {
            // Reset any previously-opened form so a fresh sold-out selection shows
            // the Notify button, not a stale open/success form (._active / .success
            // are `display: block !important`).
            $notifyForm.classList.remove('_active', 'success');
            $notifyForm.style.display = 'none';
          }
          $addToCart[0].style.setProperty('display', 'none', 'important');
        }
      }

      var lvCompareCents = '';
      if (variant.compareAtPrice && variant.compareAtPrice.amount != null) {
        lvCompareCents = String(Math.round(parseFloat(variant.compareAtPrice.amount) * 100));
      } else if (variant.compare_at_price) {
        lvCompareCents = String(variant.compare_at_price);
      }
      
      $('#compare-price').val(lvCompareCents);
      updateSalePriceColorState(variant);

      // Also update and show the product's compare price if necessary
      if (variant.compare_at_price > variant.price) {
        $comparePrice
          .html(Shopify.formatMoney(variant.compare_at_price, moneyFormat))
          .show();
      } else {
        $comparePrice.hide();
      }
 
      if(variant.id){
        const variantId = variant.id.toString().indexOf('gid:') !== -1 ? variant.id.toString().split('gid://shopify/ProductVariant/')[1] : variant.id;

        // Stash the resolved variant for the add-to-cart handler. `variant` here is
        // resolved from the FULL variant list (getAllVariants — paginated), so this
        // is authoritative even on products with >250 variants, where window.productJSON
        // is capped by Shopify and the hidden size <select> can be left empty. addToCart
        // submits this id and derives _compare-price (cents) from it. `variant` may be
        // the Storefront shape (compareAtPrice.amount, dollars) or the productJSON shape
        // (compare_at_price, cents) — normalise both to cents.
        var lvResolvedCompareCents = '';
        if (variant.compareAtPrice && variant.compareAtPrice.amount != null) {
          lvResolvedCompareCents = String(Math.round(parseFloat(variant.compareAtPrice.amount) * 100));
        } else if (variant.compare_at_price) {
          lvResolvedCompareCents = String(variant.compare_at_price);
        }
        window.__lvResolvedVariantId = String(variantId);
        window.__lvResolvedCompareCents = lvResolvedCompareCents;

        var lvNotifyEl = document.querySelector('[data-notify-variant]');
        if (lvNotifyEl) lvNotifyEl.setAttribute('data-notify-variant', variantId);
      }
    } else {
      updateSalePriceColorState(null);
      // The variant doesn't exist, disable submit button.
      // This may be an error or notice that a specific variant is not available.
      // To only show available variants, implement linked product options:
      //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
      $addToCart.addClass('disabled').prop('disabled', true);
      $addToCartText.html('select a size');
      $quantityElements.hide();
    }
  }); 

  const arrayMainImg = document.querySelectorAll(".main-image-slide");
  arrayImagesVariant = [];
  var secondOption = window.firstVariant.option2;
  if (currentColorSelected == '') {
    currentColorSelected = secondOption;
  }

  arrayMainImg.forEach((image, index) => {
    const rawColor = image.getAttribute("data-val-color");
    if (rawColor == null) return; // slide has no color (e.g. shop-this-look) — leave untouched
    const mediaType = image.getAttribute("data-media-type");
    if (mediaType === 'video' || mediaType === 'external_video') return;
    const attributeImage = rawColor.toLowerCase();
    const currentColorTrimmed = (currentColorSelected || '')
    .toLowerCase()
    .replace(/^0+/, '');

    if (attributeImage.includes(currentColorTrimmed.toLowerCase())) {
      image.classList.add('active-image-main-to-show');
      image.classList.remove('hidde-image-main-to-show');
      arrayImagesVariant.push(index);

      const img = image.querySelector('img');
      if (!img.hasAttribute('src') && img.hasAttribute('data-src')) {
        img.setAttribute('src', img.getAttribute('data-src'));
      }
    } else {
      image.classList.add('hidde-image-main-to-show');
      image.classList.remove('active-image-main-to-show');
    }
  });
fetch('/cart.js');
};

Lemonade.sizeGuide = function () {
  let sizeGuideReturnFocus = null;
  var $sizeTrigger = $('.SizeguideTrigger');
  $sizeGuide = $('#SizeguideStage');

  var $sizeTriggerMen = $('.SizeguideTriggerMen');
  $sizeGuideMen = $('#SizeguideStageMen');

  var $sizeTriggerWomen = $('.SizeguideTriggerWomen');
  $sizeGuideWomen = $('#SizeguideStageWomen');

  function closeSizeGuide() {
    $sizeTrigger.attr('aria-expanded', false);
    $sizeGuide.removeClass('Show').attr('aria-hidden', 'true');
    $sizeTriggerMen.attr('aria-expanded', false);
    $sizeGuideMen.removeClass('Show').attr('aria-hidden', 'true');
    $sizeTriggerWomen.attr('aria-expanded', false);
    $sizeGuideWomen.removeClass('Show').attr('aria-hidden', 'true');
    $('#SizeguideMetafields').removeClass('Show').attr('aria-hidden', 'true');
    Lemonade.scrollYes();

    if (sizeGuideReturnFocus) {
      $(sizeGuideReturnFocus).trigger('focus');
      sizeGuideReturnFocus = null;
    }
  }

  function openSizeGuideStage() {
    return document.querySelector('#SizeguideStage.Show, #SizeguideStageMen.Show, #SizeguideStageWomen.Show, #SizeguideMetafields.Show');
  }

  function sizeGuideFocusable(root) {
    return Array.from(root.querySelectorAll('a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])'))
      .filter(function (el) {
        return !el.disabled &&
          el.getAttribute('aria-hidden') !== 'true' &&
          el.getClientRects().length > 0 &&
          getComputedStyle(el).visibility !== 'hidden';
      });
  }

  // Focus the dialog itself, not the close button: opening by mouse then shows no ring,
  // while the first Tab still lands on the close button and does show one.
  function focusIntoSizeGuide(root) {
    if (!root) return;
    var dialog = root.querySelector('.sizeguide-inner, .sg-meta-inner') || root;
    if (!dialog.hasAttribute('tabindex')) dialog.setAttribute('tabindex', '-1');
    
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if (root.classList.contains('Show')) dialog.focus();
      });
    });
  }

  Lemonade.cache.$body.on('click', '.SizeguideTrigger', function (e) {
    e.preventDefault();
    sizeGuideReturnFocus = this;
    var $sgMeta = $('#SizeguideMetafields');
    if (window.lvHasSizeGuideMetafields && $sgMeta.length) {
      $sgMeta.addClass('Show').attr('aria-hidden', 'false');
      this.blur();
      Lemonade.scrollNo();
      focusIntoSizeGuide($sgMeta[0]);
      return;
    }
    $sizeTrigger.attr('aria-expanded', true);
    $sizeGuide.addClass('Show').attr('aria-hidden', 'false');
    this.blur();
    Lemonade.scrollNo();
    focusIntoSizeGuide($sizeGuide[0]);
  });

  Lemonade.cache.$body.on('click', '.SizeguideTriggerMen', function (e) {
    e.preventDefault();
    sizeGuideReturnFocus = this;
    $sizeTriggerMen.attr('aria-expanded', true);
    $sizeGuideMen.addClass('Show').attr('aria-hidden', 'false');
    this.blur();
    Lemonade.scrollNo();
    focusIntoSizeGuide($sizeGuideMen[0]);
  });

  Lemonade.cache.$body.on('click', '.SizeguideTriggerWomen', function (e) {
    e.preventDefault();
    sizeGuideReturnFocus = this;
    $sizeTriggerWomen.attr('aria-expanded', true);
    $sizeGuideWomen.addClass('Show').attr('aria-hidden', 'false');
    this.blur();
    Lemonade.scrollNo();
    focusIntoSizeGuide($sizeGuideWomen[0]);
  });

  // real <a>/<button> triggers activate on Enter natively; these are divs
  Lemonade.cache.$body.on('keydown', '.SizeguideTrigger, .SizeguideTriggerMen, .SizeguideTriggerWomen', function (e) {
    if (this.tagName === 'A' || this.tagName === 'BUTTON') return;
    if (e.key !== 'Enter' && e.key !== ' ' && e.keyCode !== 13 && e.keyCode !== 32) return;
    e.preventDefault();
    $(this).trigger('click');
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' && e.keyCode !== 9) return;
    var root = openSizeGuideStage();
    if (!root) return;
    var focusable = sizeGuideFocusable(root);
    if (!focusable.length) {
      e.preventDefault();
      return;
    }
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    var active = document.activeElement;
    if (!root.contains(active)) {
      e.preventDefault();
      first.focus();
    } else if (e.shiftKey && active === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && active === last) {
      e.preventDefault();
      first.focus();
    }
  }, true);

  document.addEventListener('focusin', function (e) {
    var root = openSizeGuideStage();
    if (!root || root.contains(e.target)) return;
    var focusable = sizeGuideFocusable(root);
    if (focusable.length) focusable[0].focus();
  });

  Lemonade.cache.$body.on('click', '.sg-btn', function (e) {
    e.preventDefault();
    var $me = $(this),
      meTable = $me.attr('data-table'),
      meUnit = $me.attr('data-unit');

    $('.sizeguide-header').find('.title-lg span').text(`(${meUnit})`);
    $me.hide().siblings('.sg-btn').show();
    // $(`#${meTable}`).show().siblings('.sg-t').hide();

    $('.sg-t').hide();
    $(`.${meTable}`).show();

    // the clicked button is the one that gets hidden, so keep focus on its replacement
    $me.siblings('.sg-btn').filter(':visible').first().trigger('focus');
  });

  Lemonade.cache.$body.on('click', '#SizeguideMetafields', function (e) {
    if ($(e.target).closest('.sg-meta-inner').length > 0) return;
    closeSizeGuide();
  });

  Lemonade.cache.$body.on('click', '.sg-meta-close', function () {
    closeSizeGuide();
  });

  Lemonade.cache.$body.on('click', '.sg-meta-tab', function () {
    var $btn = $(this);
    var tab = $btn.data('tab');
    $btn.addClass('is-active').siblings('.sg-meta-tab').removeClass('is-active');
    var $modal = $btn.closest('#SizeguideMetafields');
    $modal.find('.sg-meta-table').hide();
    $modal.find('.sg-meta-table--' + tab).show();
  });

  Lemonade.cache.$body.on('click', '#SizeguideStage, #SizeguideStageMen, #SizeguideStageWomen', function (e) {
    if ($(e.target).closest('.sizeguide-inner').length > 0) {
      return;
    }

    closeSizeGuide();
  });

  Lemonade.cache.$body.on('keyup', function (e) {
    const isEscape = e.key === 'Escape' || e.keyCode === 27;
    if (!isEscape) {
      return;
    }

    if ($sizeGuide.hasClass('Show') || $sizeGuideMen.hasClass('Show') || $sizeGuideWomen.hasClass('Show') || $('#SizeguideMetafields').hasClass('Show')) {
      closeSizeGuide();
    }
  });

  Lemonade.cache.$body.on('click', '.closeSizeguide', closeSizeGuide);

  Lemonade.cache.$body.on('mouseenter', '#SizeguideMetafields .sg-meta-table td', function () {
    var $cell = $(this);
    var $table = $cell.closest('table');
    var colIndex = $cell.index();
    $table.find('.sg-hover-cell, .sg-hover-line').removeClass('sg-hover-cell sg-hover-line');
    $cell.closest('tr').children('td').addClass('sg-hover-line');
    $table.find('tr').each(function () {
      var $col = $(this).children().eq(colIndex);
      if ($col.is('td')) $col.addClass('sg-hover-line');
    });
    $cell.removeClass('sg-hover-line').addClass('sg-hover-cell');
  });

  Lemonade.cache.$body.on('mouseleave', '#SizeguideMetafields .sg-meta-table table', function () {
    $(this).find('.sg-hover-cell, .sg-hover-line').removeClass('sg-hover-cell sg-hover-line');
  });
};

// Product Page Features (option select fields, Image Toggle, Zoom, Size Guide)
Lemonade.productPage = function () {

  var $productImages = $('#product-images'),
    $productSlick = $('.ProductSlick');

  // Set the first main product image based on the current selected variant (see mainImageToggle function)
  var firstcolor = null;

  if (window.firstVariant.option2) {
    firstcolor = Utilities.handleize(window.firstVariant.option2);
  }

  function initMobileStickyAddToCart() {
    const anchor = document.querySelector('[data-mobile-sticky-anchor]');
    const wrapper = anchor ? anchor.querySelector('[data-mobile-sticky-wrapper]') : null;
    const mobileMedia = window.matchMedia('(max-width: 991px)');
    const stickyMode = anchor ? anchor.getAttribute('data-mobile-sticky-mode') || 'always' : 'always';
    const stickyAnimationDuration = 220;
    let resizeObserver = null;
    let scheduledUpdate = false;
    let leavingTimeout = null;
    let stableViewportHeight = window.innerHeight;
    let stableHeaderBottom = 0;
    let viewportStabilizeTimer = null;

    if (!anchor || !wrapper) {
      return;
    }

    function isElementRendered(element) {
      if (!element) {
        return false;
      }

      const computedStyle = window.getComputedStyle(element);
      if (computedStyle.display === 'none' || computedStyle.visibility === 'hidden') {
        return false;
      }

      return element.getBoundingClientRect().height > 0;
    }

    function measureViewportTopOffset() {
      const appHeader = document.getElementById('AppHeader');
      const headerFlex = document.getElementById('header-flex');
      const bannerSection = document.getElementById('shopify-section-banner');
      let viewportTopOffset = 0;

      if (isElementRendered(bannerSection)) {
        viewportTopOffset = Math.max(viewportTopOffset, bannerSection.getBoundingClientRect().bottom);
      }

      if (headerFlex && !headerFlex.classList.contains('hidden') && isElementRendered(headerFlex)) {
        viewportTopOffset = Math.max(viewportTopOffset, headerFlex.getBoundingClientRect().bottom);
      } else if (!bannerSection && isElementRendered(appHeader)) {
        viewportTopOffset = Math.max(viewportTopOffset, appHeader.getBoundingClientRect().bottom);
      }

      return Math.max(0, Math.min(window.innerHeight, viewportTopOffset));
    }

    function refreshStableViewport() {
      viewportStabilizeTimer = null;
      stableViewportHeight = window.innerHeight;
      stableHeaderBottom = measureViewportTopOffset();
      requestPinnedStateUpdate();
    }

    function getViewportTopOffset() {
      return stableHeaderBottom;
    }

    function isAnchorFullyVisible() {
      const anchorRect = anchor.getBoundingClientRect();
      const viewportTop = getViewportTopOffset();
      const viewportBottom = stableViewportHeight;
      const tolerance = 4;
      const visibleTop = Math.max(anchorRect.top, viewportTop);
      const visibleBottom = Math.min(anchorRect.bottom, viewportBottom);
      const visibleHeight = Math.max(0, visibleBottom - visibleTop);

      if (anchorRect.height <= 0) {
        return false;
      }

      return anchorRect.top >= viewportTop + tolerance &&
        anchorRect.bottom <= viewportBottom - tolerance &&
        visibleHeight >= Math.max(0, anchorRect.height - (tolerance * 2));
    }

    function syncAnchorHeight() {
      if (!mobileMedia.matches || stickyMode !== 'when_not_visible') {
        anchor.style.removeProperty('--mobile-sticky-anchor-height');
        return;
      }

      const wrapperRect = wrapper.getBoundingClientRect();
      const wrapperStyles = window.getComputedStyle(wrapper);
      const paddingTop = parseFloat(wrapperStyles.paddingTop) || 0;
      const paddingBottom = parseFloat(wrapperStyles.paddingBottom) || 0;
      const contentHeight = Math.max(0, wrapperRect.height - paddingTop - paddingBottom);

      anchor.style.setProperty('--mobile-sticky-anchor-height', contentHeight + 'px');
    }

    function setPinnedState(isPinned) {
      if (!mobileMedia.matches || stickyMode !== 'when_not_visible') {
        anchor.classList.remove('product__mobile-sticky-anchor--pinned');
        anchor.classList.remove('product__mobile-sticky-anchor--leaving');
        return;
      }

      if (leavingTimeout) {
        window.clearTimeout(leavingTimeout);
        leavingTimeout = null;
      }

      if (isPinned) {
        anchor.classList.remove('product__mobile-sticky-anchor--leaving');
        if (!anchor.classList.contains('product__mobile-sticky-anchor--pinned')) {
          anchor.classList.add('product__mobile-sticky-anchor--pinned');
        }
      } else if (anchor.classList.contains('product__mobile-sticky-anchor--pinned')) {
        anchor.classList.remove('product__mobile-sticky-anchor--pinned');
        anchor.classList.add('product__mobile-sticky-anchor--leaving');
        leavingTimeout = window.setTimeout(function () {
          anchor.classList.remove('product__mobile-sticky-anchor--leaving');
          leavingTimeout = null;
          syncAnchorHeight();
        }, stickyAnimationDuration);
      } else {
        anchor.classList.remove('product__mobile-sticky-anchor--leaving');
      }

      syncAnchorHeight();
    }

    function destroyObservers() {
      if (resizeObserver) {
        resizeObserver.disconnect();
        resizeObserver = null;
      }
    }

    function updatePinnedState() {
      scheduledUpdate = false;

      if (!mobileMedia.matches || stickyMode !== 'when_not_visible') {
        setPinnedState(false);
        return;
      }

      setPinnedState(!isAnchorFullyVisible());
    }

    function requestPinnedStateUpdate() {
      if (scheduledUpdate) {
        return;
      }

      scheduledUpdate = true;
      window.requestAnimationFrame(updatePinnedState);
    }

    function setupConditionalStickyMode() {
      destroyObservers();
      syncAnchorHeight();

      if (!mobileMedia.matches || stickyMode !== 'when_not_visible') {
        setPinnedState(false);
        return;
      }

      requestPinnedStateUpdate();

      if (typeof ResizeObserver === 'function') {
        resizeObserver = new ResizeObserver(function () {
          syncAnchorHeight();
          requestPinnedStateUpdate();
        });
        resizeObserver.observe(wrapper);
      }
    }

    stableHeaderBottom = measureViewportTopOffset();

    setupConditionalStickyMode();
    if (typeof mobileMedia.addEventListener === 'function') {
      mobileMedia.addEventListener('change', setupConditionalStickyMode);
    } else if (typeof mobileMedia.addListener === 'function') {
      mobileMedia.addListener(setupConditionalStickyMode);
    }
    window.addEventListener('load', function () {
      stableHeaderBottom = measureViewportTopOffset();
      requestPinnedStateUpdate();
    });
    window.addEventListener('resize', function () {
      syncAnchorHeight();
      if (viewportStabilizeTimer) clearTimeout(viewportStabilizeTimer);
      viewportStabilizeTimer = setTimeout(refreshStableViewport, 200);
    });
    window.addEventListener('scroll', requestPinnedStateUpdate, { passive: true });
  }

  // Build custom UI for product select fields
  function customSelectsUI() {
    var $selectorWrap = $('.selector-wrapper');
    var tamanhos = {};
    var values = {};
    var cores = {};

    const productId = window.item.ProductID;
    const handle = document.querySelector('.product-variants')?.dataset.handle;
    if (!handle) return;
    const allVariants = Lemonade.getAllVariants(handle);

    // Build a map: color -> Set(sizes) of variants that actually exist for this product.
    // Used to hide size swatches for combinations that do not exist (e.g. color 00BR13 + size XL).
    allVariants.then(function (variants) {
      const map = {};
      variants.flat().forEach(v => {
        const color = v.selectedOptions.find(o => o.name === 'Color')?.value;
        const size = v.selectedOptions.find(o => o.name === 'Size')?.value;
        if (!color || !size) return;
        if (!map[color]) map[color] = new Set();
        map[color].add(size);
      });
      window.sizesByColor = map;
    });

    $selectorWrap.each(function (i, el) {
      var $me = $(el),
        $meSelect = $me.find('.single-option-selector'),
        $meLabel = $me.find('label'),
        meLabelText = $meLabel.text(),
        $meOptions = $me.find('option'),
        $MeUl = $('<div class="selector-options"></div>'),
        $newLabel = $('<div class="selector-label">' + meLabelText + '<span class="selection-label"></span></div>'),
        optionType = Utilities.handleize(meLabelText),
        firstOption = window.firstVariant.option1,
        secondOption = window.firstVariant.option2;

      if (optionType == 'size') {
        $newLabel = $(`<div class="selector-label">${meLabelText}:<span class="selection-label"></span></div>`);
        if ($meOptions.length == 1) {
          sizeSelected = true;
        }
      }

      if (optionType == 'color') {
        $newLabel = $(`<div class="selector-label limit-colors">Limited Colors <span class="selection-label"></span> <div role="button" aria-label="Sizeguide expand" aria-controls="SizeguideStage" tabindex="0" class="SizeguideTrigger sizeguide-trigger" id="SizeguideTrigger">${liquidVars.sizeGuide}</div></div>`);
      }

      if ($me.hasClass("color-core")) {
        $newLabel = $(`<div class="selector-label">Core Colors: <span class="selection-label"></span> <div role="button" aria-label="Sizeguide expand" aria-controls="SizeguideStage" tabindex="0" class="SizeguideTrigger sizeguide-trigger" id="SizeguideTrigger">${liquidVars.sizeGuide}</div></div>`);
      }

      if (optionType == 'size') {
        if ($meOptions.length == 1) {
          sizeSelected = true;
        }
      }

      $me.addClass(optionType);

      // build options in option select dropdown with data-attributes derived from real select
      $meOptions.each(async function (i, el) {
        var $el = $(el),
          meText = $el.text(),
          meVal = $el.val().replace(/["]/g, "&quot;"),
          meHandle = meText.replace(/["]/g, "&quot;"),
          meHandle = meHandle.toLowerCase(),
          isCurrent = '',
          classes = i == 0 ? 'Active' : '';

        if (meText == firstOption || meText == secondOption) {
          isCurrent = 'Active';
        }
      });

      const orderedOptionValues = Array.from($meOptions)
        .map(option => option.value || option.text)
        .filter(Boolean);

      allVariants.then(function (variants2) {
        const onlyVariants = variants2.flat();          
        var alreadyCurrentSet = false;

        onlyVariants.forEach(variant => {
          const variantId = variant.id.split('/').pop();              
          if (optionType == "color") {
            var color = variant.selectedOptions.find(o => o.name == 'Color')?.value;
            if (color && !cores[color]){
              cores[color] = { color: color };

              var meText = color,
              meHandle = meText.replace(/["]/g, "&quot;"),
              meHandle = meHandle.toLowerCase(),
              isCurrent = '';

              const variantIsActive = variant?.metafield?.value == null || String(variant.metafield.value).toLowerCase() === 'true';

              if (!alreadyCurrentSet && ((meText == firstOption && variantIsActive || meText == secondOption && variantIsActive) || variantIsActive)) {
                isCurrent = 'Active';
                alreadyCurrentSet = true;
              }

              $MeUl.append(`<div 
                data-option-type="color" 
                style="background-image: url(${liquidVars.filePath}/${meHandle}.png)" 
                role="button" 
                tabindex="0" 
                class="color-${meHandle.replace(' ', '-').replace('/', '-')} ${isCurrent}" 
                data-val="${meText}">                
                <span class="inventory-status">${meText}</span>
                </div>`)
            }
          }
          var tamanho = variant.selectedOptions.find(o => o.name === 'Size')?.value;       
        
          if (tamanho && !tamanhos[tamanho]) {     
            tamanhos[tamanho] = { size: tamanho };
          }    
          
          var value = variant.selectedOptions.find(o => o.name === 'Values')?.value;
          if (value && !values[value]) {
            values[value] = { value: value, variantId: variantId  };
          }
        });

        var tamanos = onlyVariants.filter(x => x.selectedOptions.find(o => o.name == 'Color')?.value == secondOption);
        const tamanhosExistentes = tamanos.map(v =>
          v.selectedOptions.find(o => o.name === 'Size')?.value
        );

        const orderedSizes = orderedOptionValues.filter(value => tamanhos[value]);
        const fallbackSizes = Object.keys(tamanhos).filter(value => !orderedSizes.includes(value));

        orderedSizes.concat(fallbackSizes).forEach(tamanho => {
          if (!tamanhosExistentes.includes(tamanho)) {
            $MeUl.append(
              `<div data-option-type="${tamanho}" 
              role="button" 
              tabindex="0" 
              class="${tamanho} soldout" 
              data-val="${tamanho}">
              <span class="inventory-status">${tamanho}</span>
              </div>`
            );
          } else {
            $MeUl.append(
              `<div data-option-type="${tamanho}" 
              role="button" 
              tabindex="0" 
              class="${tamanho}" 
              data-val="${tamanho}">
              <span class="inventory-status">${tamanho}</span>
              </div>`
            );
          }
        });

        
        var Values2 = onlyVariants.filter(x => x.selectedOptions.find(o => o.name == 'Color')?.value == secondOption && x.availableForSale);
        const existingValues = Values2.map(v =>
          v.selectedOptions.find(o => o.name === 'Values')?.value
        );

        Object.keys(values).forEach(value => {
          if (!existingValues.includes(value)) {
            $MeUl.append(
              `<div data-option-type="${value}" 
              role="button" 
              tabindex="0" 
              class="${value} soldout"               
              data-val-id="${values[value].variantId}"
              data-val="${value}"
              data-prod-id="${productId}">
              <span class="inventory-status">${value}</span>
              </div>`
            );
          } else {
            $MeUl.append(
              `<div data-option-type="${value}" 
              role="button" 
              tabindex="0" 
              class="${value}"     
              data-val-id="${values[value].variantId}"  
              data-val="${value}"
              data-prod-id="${productId}">
              <span class="inventory-status">${value}</span>
              </div>`
            );
          }
        });

      });
      // Hide default select field + label
      $meLabel.add($meSelect).hide();

      // Add new selections to DOM
      $me.prepend($MeUl).prepend($newLabel);

      // Add size guide button after the size options
      if (optionType == 'size') {
        $me.append(`
          <div role="button" aria-label="Sizeguide expand" aria-controls="SizeguideStage" tabindex="0" class="SizeguideTrigger sizeguide-trigger"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="12" viewBox="0 0 18 12" fill="none" aria-hidden="true" focusable="false">
            <path d="M16.4639 0.5C16.9498 0.500077 17.3452 0.773003 17.6006 1.125C17.8564 1.47777 18 1.94036 18 2.42871V9.57129C18 10.0596 17.8564 10.5222 17.6006 10.875C17.3452 11.227 16.9498 11.4999 16.4639 11.5H1.8418C1.40717 11.4999 1.03458 11.2651 0.788086 10.9307C0.543468 10.5987 0.420899 10.1728 0.420898 9.75V2.42871C0.420906 1.94044 0.563558 1.47775 0.819336 1.125C1.07473 0.772859 1.47093 0.500019 1.95703 0.5H16.4639ZM1.95703 1.5C1.87118 1.50002 1.74858 1.54691 1.62891 1.71191C1.50968 1.87631 1.42091 2.12835 1.4209 2.42871V9.75C1.4209 9.98994 1.4921 10.2 1.59277 10.3369C1.69162 10.4711 1.78795 10.4999 1.8418 10.5H16.4639C16.5496 10.4999 16.6715 10.4527 16.791 10.2881C16.9102 10.1237 17 9.87166 17 9.57129V2.42871C17 2.12834 16.9102 1.87631 16.791 1.71191C16.6715 1.54732 16.5496 1.50008 16.4639 1.5H15.2363V5C15.2363 5.27614 15.0125 5.5 14.7363 5.5C14.4604 5.4998 14.2363 5.27602 14.2363 5V1.5H12.4736V4C12.4736 4.27611 12.2497 4.49995 11.9736 4.5C11.6975 4.5 11.4736 4.27614 11.4736 4V1.5H9.70996V5C9.70996 5.27614 9.4861 5.5 9.20996 5.5C8.93401 5.49978 8.70996 5.276 8.70996 5V1.5H6.94727V4C6.94727 4.27613 6.72338 4.49997 6.44727 4.5C6.17112 4.5 5.94727 4.27614 5.94727 4V1.5H4.18359V5C4.18359 5.27614 3.95974 5.5 3.68359 5.5C3.40766 5.49975 3.18359 5.27599 3.18359 5V1.5H1.95703Z" fill="#2D2926"/>
          </svg>${liquidVars.sizeGuide}</div>
        `);
      }

      // Set default option UI
      if (optionType == 'color') {
        $me.find('.selector-label .selection-label').text(secondOption);
      }
    });

    // After swatches are rendered (rendering happens inside per-wrapper allVariants.then),
    // sync the selected color into ProductOptionSelectors. This .then() is registered
    // last on the same allVariants promise, so it runs after the rendering callbacks
    // (i.e. the .color-<handle> swatches already exist here).
    allVariants.then(function () {
      // The color actually selected on load: the Main Color metafield when the page
      // was opened without a ?variant= param, otherwise the resolved variant's color.
      var desiredColor = (!window.pdpHasVariantParam && window.pdpMainColor)
        ? window.pdpMainColor
        : (window.firstVariant && window.firstVariant.option2);
      if (!desiredColor) return;

      // Push the selected color into the ProductOptionSelectors color option (option2).
      // The page-init proxy click (product-form.liquid, on DOMContentLoaded) ran
      // BEFORE these .color-<handle> swatches existed — they are built here, on
      // window 'load', after the async variant fetch — so its `.color-<x>?.click()`
      // was a no-op and ProductOptionSelectors was left on the first variant's color.
      // That desync made a size change resolve the wrong-color variant (gallery
      // jumped to another color, availability was read for the wrong variant).
      // Clicking the matching swatch now syncs option2 and re-resolves the correct
      // variant + images; customSelectsClick also runs updateSizeVisibility for it.
      var norm = String(desiredColor).trim().toLowerCase();
      var $match = $('.selector-wrapper.color .selector-options > div[data-option-type="color"]').filter(function () {
        return String($(this).data('val') || '').trim().toLowerCase() === norm;
      }).first();

      if ($match.length && !$match.hasClass('Active')) {
        $match.trigger('click');
      } else {
        updateSizeVisibility(desiredColor);
        
        var $activeColor = $('.product-variants .selector-wrapper.color .selector-options > div.Active[data-option-type="color"]').first();
        var $o2 = $('.product-variants .single-option-selector[data-option="option2"]');
        if ($activeColor.length && $o2.length) {
          $o2.val($activeColor.data('val')).trigger('change');
        }
      }
    });
  };

  function updateSizeVisibility(color) {
    if (!window.sizesByColor) return;
    const sizes = window.sizesByColor[color];
    if (!sizes) return;
    const root = document.querySelector('.product-variants');
    const scope = root ? $(root) : $(document);
    scope.find('.selector-wrapper.size .selector-options > div').each(function () {
      const $opt = $(this);
      const val = String($opt.data('val'));
      if (sizes.has(val)) {
        $opt.removeClass('variant-not-existing').show();
      } else {
        $opt.addClass('variant-not-existing').hide();
      }
    });
  }

  // Custom product select UI events
  function customSelectsClick() {

    $('.product-variants').on('keydown', '.selector-options div', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ' && e.keyCode !== 13 && e.keyCode !== 32) return;
      e.preventDefault();
      $(this).trigger('click');
    });

    // .Active/.soldout are toggled from several places in the variant logic, so the
    // matching ARIA is mirrored from the classes instead of set at each call site
    function syncSwatchState(root) {
      $(root).find('.selector-options > div').each(function () {
        // aria-pressed is only meaningful on a button role, and Swiper rewrites the role
        if (this.getAttribute('role') !== 'button') this.setAttribute('role', 'button');
        this.setAttribute('aria-pressed', this.classList.contains('Active') ? 'true' : 'false');
        if (this.classList.contains('soldout')) {
          this.setAttribute('aria-disabled', 'true');
        } else {
          this.removeAttribute('aria-disabled');
        }
      });
    }

    $('.product-variants').each(function () {
      const root = this;
      syncSwatchState(root);
      new MutationObserver(function (records) {
        const touched = records.some(function (r) {
          const t = r.target;
          if (t.classList && t.classList.contains('selector-options')) return true;
          return t.parentNode && t.parentNode.classList && t.parentNode.classList.contains('selector-options');
        });
        if (touched) syncSwatchState(root);
      }).observe(root, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['class', 'role']
      });
    });

    $('.product-variants').on('click', '.selector-options div', async function (e) {
      //e.stopPropagation();
      var $me = $(this),
        meVal = $me.data('val'),
        meText = $me.text(),
        meColor = Utilities.handleize(meText),
        optionType = $me.data('option-type'),
        $meSelectorWrap = $me.closest('.selector-wrapper'),
        imageContainertHeight = $productImages.outerHeight();

      if (optionType == 'size') {
        currentSelected1 = meVal;
      } else if (optionType == 'color') {
        currentSelected2 = meVal;
        updateSizeVisibility(meVal);
      }

      $meSelectorWrap.find('.selector-label .selection-label').text(meText);

      // Temporarily set the height of the product image container.
      // This is for the purpose of avoiding any screen blips while new content is loaded in and the UI updates
      // Once the new images are loaded into the UI the height will return to auto.
      $productImages.height(imageContainertHeight);

      if (!$me.hasClass('Active')) {

        if ($me.hasClass("color")) {
          const productColorInfo = Utilities.getColorNameByCode(meVal);

          if (productColorInfo["CORE"]) {
            document.querySelector(".color-core .selector-label .selection-label").innerHTML = productColorInfo["COLOR NAME"]
            if (document.querySelector(".color .selector-label.limit-colors .selection-label")) {
              document.querySelector(".color .selector-label.limit-colors .selection-label").innerHTML = ""
            }
          } else {
            document.querySelector(".color .selector-label.limit-colors .selection-label").innerHTML = productColorInfo["COLOR NAME"]
          }

          document.querySelectorAll(".selector-options .color").forEach(option => {
            option.classList.remove("Active");
          });
          $(this).addClass("Active")
          document.querySelectorAll(".single-option-selector").forEach(option => {
            if (option.getAttribute("data-option") === "option2") {
              $(option).val($(this).data('val')).change()
            }
          })

        } else {
          $me
            .addClass('Active')
            .siblings('div')
            .removeClass('Active')
            .end()
            .closest('.selector-wrapper')
            .find('.single-option-selector')
            .val(meVal)
            .change();
        }


        if ($me.closest('.selector-wrapper').hasClass('color')) {
          mainImageToggle(meColor);
        }

        var priceMarkup = `${liquidVars.addToBag}`;
        if (currentComparePrice && currentComparePrice != null) {
          priceMarkup = `${liquidVars.addToBag}`;
        }

        if ($me.closest('.selector-wrapper').hasClass('size')) {
          sizeSelected = true;
          if (currentAvailable) {
            $('#AddToCart').removeClass('disabled').prop('disabled', false);
            $('#AddToCartText').html(priceMarkup);
          }

          if (sizeErrorTimeout) {
            clearTimeout(sizeErrorTimeout);
            sizeErrorTimeout = null;
          }
          $me.closest('.selector-wrapper.size').removeClass('size-error');
          const $sizeErrorMsg = $me.closest('.product-form').find('.size-error-message');
          if ($sizeErrorMsg.length) $sizeErrorMsg.hide();
        }
        $('.note.errors').text('');
        Utilities.getColorNameByCode(meVal)
      }

    });
  };

  // Get the product images that correlate to the currently selected color.
  function filterImagesByColorSelection(fields, colorCheck) {
    var colorupcase = colorCheck.toUpperCase(),
      result = [];

    for (var i = 0; i < fields.results.length; i++) {
      if (fields.results[i].path.includes(colorupcase)) {
        fields.results[i].color = colorupcase;
        result.push(fields.results[i]);
      }
    }
    return result;
  }

  function CalcPrice(color) {
    const settings = window.themeSettings;
    if (settings && settings.showDiscountPercentagePdp) {
      const productId = window.item.ProductID;
      const variantElement = document.querySelector(`.variant[data-product-id="${productId}"][data-variant-color="${color.toLowerCase()}"]`);
      if (variantElement) {
        const price = variantElement.getAttribute('data-variant-price');
        const priceCompare = variantElement.getAttribute('data-variant-compare-at-price');
        if (price && priceCompare) {
            if (priceCompare > 0) {
              const discountPercent = ((priceCompare - price) / priceCompare) * 100;
              return `-${Math.round(discountPercent)}%`;
            }
            else {
              return "";
            }
        }
        return "";
      }
    }
    return "";
  }
  // Only on mobile
  // Main PDP image toggle with current selected color
  function mainImageToggle(meColor) {
    // fields calculated on product-js.liquid file
    var fields = window.productImagesJSON,
      imageResults = fields.results,
      videoResults = fields.videos,
      isMobile = false;

    // if a color option is selected filter the images to only the selected color
    if (meColor) {
      imageResults = filterImagesByColorSelection(fields, meColor);
    }

    // Check if on a wide or narrow screen (mobile uses a carousel whereas desktop used a stacked grid)
    if (Lemonade.cache.$body.hasClass('NarrowScreen')) {
      isMobile = true;
    }

    // Set loading state over the section while the ajax is running and the UI is updating
    $productImages.addClass('Loading');

    // Mobile and desktop need to have different UI updates
    if (isMobile && $productSlick.hasClass('slick-initialized')) {
      $productSlick.slick('unslick').empty();
    } else {
      $productSlick.empty();
    }

    // Cycle through the new images array and construct the new UI
    if (imageResults.length > 0) {
      $.each(imageResults, function (i, el) {
        var index = i + 1;
        var halfWidth = '';
        var fetchPriority = 'auto';
        var loading = 'lazy';
        var width = 1200;
        if (index === 1){
          fetchPriority = 'high'
          loading = 'lazy'
        }

        if (index > 3) {
          halfWidth = 'half'
        }
        var item = `<div data-img-path="${el.image}" id="ProductImage${index}" class=" ${halfWidth} ${el.color} ProductImage "><span class="sale-value">${CalcPrice(el.color)}</span><img fetchpriority="${fetchPriority}" loading="${loading}" width="1200" height="1200" class="TakeoverImg" aria-controls="ZoomStage" data-lg-img="${el.image_lg}" data-index="#img-${i}" data-color="${el.color}" data-handle="${el.handle}" src="${el.image}&width=${width}" alt="${(el.alt || (window.productJSON && window.productJSON.title) || 'Product image').replace(/["]/g, "&quot;")}"></div>`;
        $productSlick.append(item);
      });
    }

    // Cycle through the product videos array and construct the new UI
    if (videoResults.length > 0) {
      $.each(videoResults, function (i, el) {
        var index = i + 1;
        if (el.video_path) {
          var item = `<div id="ProductImage${index}" class="half ProductImage video"><video autoplay muted loop playsinline><source src="${el.video_path}"></video></div>`;
          $productSlick.append(item);
        }
      });
    }

    $("#ProductImage1 img").on('load', function() {
      if (isMobile && !$productSlick.hasClass('slick-initialized')) {
        $productSlick.on('init', function () {
          Lemonade.cache.$win.resize();
        });
        $productSlick.slick();
      }

      $productImages.removeClass('Loading').css({
        "height": 'auto',
        "min-height": 'auto'
      });
    })
  }

  // Full page zoom takeover
  function Zoom() {

    var source = $("#zoom-template").html(),
      template = Handlebars.compile(source),
      $zoomStage = $('#ZoomStage'),
      $zoomProducts = $('.ZoomProducts'),
      picOffset = 0;

    function showZoom(id) {
      picOffset = $zoomProducts.find(id).position().top;
      $zoomStage.scrollTop(picOffset).addClass('Show').attr('aria-hidden', false);
      Lemonade.scrollNo();
    }

    $('#product-images').on('click', '.TakeoverImg', function () {
      var $me = $(this),
        prod_handle = $me.attr('data-handle'),
        picId = $me.attr('data-index'),
        items = [];

      if ($me.attr('aria-expanded') == 'true') {
        $me.attr('aria-expanded', 'false');
      } else {
        $me.attr('aria-expanded', 'true');
      }

      $('#product-images .TakeoverImg').each(function (i, el) {
        var lg_image = $(el).attr('data-lg-img');
        // the zoom template has no alt of its own, so carry the thumbnail's over
        items.push({ image: lg_image, alt: el.alt || (window.productJSON && window.productJSON.title) || 'Product image' });
      });

      $.ajax({
        url: '/products/' + prod_handle + '?view=json',
        dataType: 'html',
        async: true,
        success: function (meta) {
          var fields = JSON.parse(meta);
          $zoomProducts.html(template({ items: items }));
          setTimeout(() => {
            showZoom(picId);
          }, 150);
        }
      });

    });

    $(document).on('click', '#glass-zoom-mobile .TakeoverImg', function () {
      var $me = $(this),
        prod_handle = $me.attr('data-handle'),
        picId = $me.attr('data-index'),
        items = [];

      if ($me.attr('aria-expanded') == 'true') {
        $me.attr('aria-expanded', 'false');
      } else {
        $me.attr('aria-expanded', 'true');
      }

      $('#glass-zoom-mobile .TakeoverImg').each(function (i, el) {
        var lg_image = $(el).attr('data-lg-img');
        items.push({ image: lg_image, alt: el.alt || (window.productJSON && window.productJSON.title) || 'Product image' });
      });

      $.ajax({
        url: '/products/' + prod_handle + '?view=json',
        dataType: 'html',
        async: true,
        success: function (meta) {
          var fields = JSON.parse(meta);
          $zoomProducts.html(template({ items: items }));
          setTimeout(() => {
            showZoom(picId);
          }, 150);
        }
      });

    });

    $('.closeZoom').on('click', function () {
      $zoomStage.removeClass('Show').attr('aria-hidden', true);
      $zoomProducts.empty();
      Lemonade.scrollYes();
    });
  };

  customSelectsUI();
  customSelectsClick();
  Zoom();
  initMobileStickyAddToCart();
  $(window).on('load', function () {
    mainImageToggle(firstcolor);
  });

};

// Custom quantity selectors (cart flyout & cart page)
Lemonade.quantitySelector = function (el, flyout) {

  var $button = $(el),
    $qty = $button.parent().find('.Quantity'),
    oldQty = $qty.val(),
    handle = $qty.data('handle'),
    variant_id = $qty.data('variant'),
    // Target the specific line item by its unique key, not the variant id —
    // two line items can share a variant id (same variant, different line-item
    // properties), and changing by variant id would hit BOTH lines.
    lineKey = $qty.attr('data-key'),
    productGift = liquidVars.productGiftWomen || liquidVars.productGiftMen;

  // Block changing quantity for product gifts
  if (handle === productGift) {
    console.log("Can't change quantity for product gift")
    return;
  }

  if ($button.hasClass('up')) {
    var newQty = parseFloat(oldQty) + 1;
  } else {
    if (oldQty > 0) {
      var newQty = parseFloat(oldQty) - 1;
    } else {
      newQty = 0;
    }
  }

  $qty.val(newQty);

  Utilities.updateCartQuantity({ id: lineKey || variant_id, quantity: newQty }, function () {
    $qty.attr('value', newQty);
  }, false, flyout);

};

let sizeErrorTimeout = null;

// Mini cart
Lemonade.initCartFlyout = function () {
  var $addToCartBtn = $('form[action^="/cart/add"] :submit');

  function getCartJSON(callback, show_flyout, useCache = false) {
    if (useCache) {
      const initialCart = getInitialCartJson();
      if (initialCart && typeof callback !== undefined) {
        Lemonade.cache.$cartCount.text(initialCart.item_count);
        callback(initialCart, show_flyout);
        return;
      }
    }
    $.getJSON('/cart.js', function (cart) {
      if (typeof callback !== undefined) {
        Lemonade.cache.$cartCount.text(cart.item_count);
        Lemonade.cache.$cartCount.attr('data-cart-count', cart.item_count);
        callback(cart, show_flyout);
      }
    })
  }

  async function addToCart(e) {
    e.preventDefault();

    if ($(this).hasClass('disabled')) {
      const $productForm = $(this).closest('.product-form');
      if ($productForm.length) {
        const $sizeWrapper = $productForm.find('.selector-wrapper.size');
        if ($sizeWrapper.length) {
          $sizeWrapper[0].scrollIntoView({ behavior: 'smooth', block: 'center' });

          const $sizeErrorMsg = $productForm.find('.size-error-message');
          if ($sizeErrorMsg.length) $sizeErrorMsg.show();

          if (sizeErrorTimeout) {
            clearTimeout(sizeErrorTimeout);
            $sizeWrapper.removeClass('size-error');
            void $sizeWrapper[0].offsetWidth;
          }

          $sizeWrapper.addClass('size-error');
          sizeErrorTimeout = setTimeout(function () {
            $sizeWrapper.removeClass('size-error');
            sizeErrorTimeout = null;
          }, 5000);
        }
      }
      return;
    }

    var $addToCartBtn = $(this),
      $addToCartForm = $(this).closest('form'),
      $addToCartBtnText = $(this).find('span')
      $addToCartQty = $addToCartForm.find('.Quantity');

    var noteErrorsText = $('.note.errors').text();
    if($addToCartBtn.hasClass('AccTrigger')) return;

    // The lock guards the gift pop-up for as long as the add is in flight: it
    // swallows double clicks and keeps Utilities.openModalGift from re-opening
    // the pop-up from cart data that predates the add.
    var isGiftAtc = $addToCartBtn.hasClass('add-to-cart-gamification');
    var releaseGiftAtcLock = function () {
      if (isGiftAtc) window.__giftAtcLock = false;
    };

    if (isGiftAtc) {
      if (window.__giftAtcLock) return;
      window.__giftAtcLock = true;
      // Safety net in case the add never settles.
      setTimeout(releaseGiftAtcLock, 5000);
      const giftModal = document.querySelector('.gamification-modal');
      if (giftModal) giftModal.classList.remove('open');
      $('#ScreenOverlay').removeClass('Active');
    }

    if ($addToCartForm.length && noteErrorsText === "") {
      $addToCartBtn
        .attr('data-add-to-cart', $addToCartBtnText.text())
        .prop('disabled', true)
        .addClass('disabled btn--loading');
      $addToCartBtnText.hide();
      $('#AddToCartAdding').show();
      // Sync the hidden variant <select> to the shopper's swatch selection
      // before the form is serialized. The custom swatch UI updates the display
      // and the .single-option-selector values, but ProductOptionSelectors only
      // writes #productSelect on the init / ?variant= deep-link path (a jQuery
      // .change() does not reach its native change listener). Without this,
      // clicking colour/size leaves #productSelect on the initial variant and the
      // form adds the wrong (first-available) variant to cart.
      if ($addToCartForm.attr('id') === 'AddToCartForm') {
        try {
          var $lvVariantSelect = $addToCartForm.find('#productSelect');
          var lvVariants = (window.productJSON && window.productJSON.variants) || [];

          // Preferred source: the variant changeVariant resolved from the FULL variant
          // list (getAllVariants — paginated). window.productJSON is capped at 250
          // variants by Shopify, so matching the selection against it silently picks
          // the wrong variant on large products — an empty size <select> made the old
          // match wildcard to the first size (added XS), or cleared #productSelect
          // (sent id:undefined). #productSelect is rendered by Liquid with every
          // variant (not capped), so assigning the resolved id sticks and serializes.
          var lvResolvedId = (window.__lvResolvedVariantId && /^\d+$/.test(String(window.__lvResolvedVariantId)))
            ? String(window.__lvResolvedVariantId) : '';

          if (lvResolvedId && $lvVariantSelect.length) {
            if (String($lvVariantSelect.val()) !== lvResolvedId) {
              $lvVariantSelect.val(lvResolvedId);
            }
          } else if ($lvVariantSelect.length && lvVariants.length) {
            // Fallback (changeVariant hasn't resolved yet): match the selectors against
            // productJSON, but ONLY on a COMPLETE, non-empty selection so an empty
            // <select> can't wildcard-match the wrong variant.
            var lvSelected = {};
            var lvComplete = true;
            $addToCartForm.find('.single-option-selector').each(function (lvIdx) {
              if ((this.type === 'radio' || this.type === 'checkbox') && !this.checked) return;
              var lvPos = this.getAttribute('data-option') || this.getAttribute('data-index') || ('option' + (lvIdx + 1));
              var lvVal = String(this.value);
              if (lvVal === '') lvComplete = false;
              lvSelected[lvPos] = lvVal;
            });
            if (lvComplete && Object.keys(lvSelected).length) {
              for (var lvI = 0; lvI < lvVariants.length; lvI++) {
                var lvV = lvVariants[lvI];
                if ((!lvSelected.option1 || String(lvV.option1) === lvSelected.option1) &&
                    (!lvSelected.option2 || String(lvV.option2) === lvSelected.option2) &&
                    (!lvSelected.option3 || String(lvV.option3) === lvSelected.option3)) {
                  if (String($lvVariantSelect.val()) !== String(lvV.id)) {
                    $lvVariantSelect.val(String(lvV.id));
                  }
                  break;
                }
              }
            }
          }

          // properties[_compare-price] (cents) for the variant being submitted, so the
          // PDP, quick-add popup and PLP add produce identical line-item props and merge.
          // Prefer the resolved variant's compare (cap-proof); else look it up in
          // productJSON by the final #productSelect id. Disabled/empty → omitted from
          // .serialize() (matching the popup, which omits the property when empty).
          var $lvCompareInput = $addToCartForm.find('#compare-price');
          if ($lvCompareInput.length) {
            var lvCompareCents = '';
            if (lvResolvedId && String(window.__lvResolvedVariantId) === lvResolvedId && window.__lvResolvedCompareCents) {
              lvCompareCents = String(window.__lvResolvedCompareCents);
            } else if ($lvVariantSelect.length && lvVariants.length) {
              var lvFinalId = String($lvVariantSelect.val());
              for (var lvJ = 0; lvJ < lvVariants.length; lvJ++) {
                if (String(lvVariants[lvJ].id) === lvFinalId) {
                  if (lvVariants[lvJ].compare_at_price) lvCompareCents = String(lvVariants[lvJ].compare_at_price);
                  break;
                }
              }
            }
            if (lvCompareCents) {
              $lvCompareInput.prop('disabled', false).val(lvCompareCents);
            } else {
              $lvCompareInput.val('').prop('disabled', true);
            }
          }
        } catch (lvErr) {}
      }
      var data = $addToCartForm.serialize();
      const hasIdInForm = /(^|&)id=/.test(data);
      if (!hasIdInForm) {
        var op = $('.product-single__variants option:selected');
        var id = `${op.data('id')}`;
        data = {id: id, quantity: $addToCartQty.val() };
      }
      getCartJSON(Utilities.renderCartFlyout, false);
      const submittedVariantId = Utilities.submittedVariantId(data);
      if (Utilities.isGiftVariant(submittedVariantId)) {
        const cart = await fetch('/cart.js').then(r => r.json());
        if (Utilities.shouldBlockGiftAdd(submittedVariantId, cart)) {
          releaseGiftAtcLock();
          $addToCartBtn
            .removeClass('btn--loading')
            .prop('disabled', false)
            .removeClass('disabled btn--loading');
          return;
        }
      }

      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        type: 'post',
        data: data,
        complete: releaseGiftAtcLock,
        success: function (lineItem) {
          if (liquidVars.oneTreeProdID && liquidVars.oneTreeProdHandle) {
            $.ajax({
              url: '/cart/add.js', type: 'post', dataType: 'json',
              data: { id: parseInt(liquidVars.oneTreeProdID), quantity: $addToCartQty.val() },
              success: async function (data, textStatus, jqXHR) {
                Utilities.createCookie()
                $addToCartBtn
                  .removeClass('btn--loading')
                  .prop('disabled', false)
                  .removeClass('disabled btn--loading');
                $addToCartBtnText.show();
                $('#AddToCartAdding').hide();
                // No gamification() call here: it would run on the cached
                // #current-cart-json, which still predates this add. The
                // renderCartFlyout below refreshes that cache with a fresh cart
                // and runs gamification() itself (see Utilities.setCartData).
                const isMobileDevice = Utilities.isMobileDevice();
                if (isMobileDevice && !document.querySelector("#CartFlyout").classList.contains("Show")) {
                  getCartJSON(Utilities.renderCartFlyout, false);
                  const mobileCart = await fetch('/cart.js').then(r => r.json());
                  if (mobileCart.items.length > 0) {
                    const productsFilter = mobileCart.items.filter(x => x.product_title !== "One Tree Planted")
                    Utilities.handleSidecartPopUp(productsFilter[0].product_title)
                  }
                } else {
                  getCartJSON(Utilities.renderCartFlyout, true);
                }
                const cart = await fetch('/cart.js').then(r => r.json())
                var totalCurrency = document.querySelector("#Subtotal");
                if (totalCurrency) {
                  totalCurrency.innerHTML = Utilities.cartTotalHtml(cart);
                }
              },
              error: function (jqXHR, textStatus, errorThrown) {
                if(jqXHR.responseJSON && jqXHR.responseJSON.description) {
                  var response = jqXHR.responseJSON.description;
                  $addToCartBtn.closest('.btn-wrap').append('<p class="note errors">' + response + '</p>');
                }
                $addToCartBtn
                  .removeClass('btn--loading')
                  .prop('disabled', false)
                  .removeClass('disabled btn--loading');

                $addToCartBtnText.text('Add To Cart');
                $addToCartBtnText.show();
                $('#AddToCartAdding').text('Adding...');
                $('#AddToCartAdding').hide();
              }
            });
          } else {
            $addToCartBtn
              .removeClass('btn--loading')
              .prop('disabled', false)
              .removeClass('disabled btn--loading');
            //$addToCartBtnText.text(liquidVars.addToCart);
            $addToCartBtnText.show();
            $('#AddToCartAdding').hide();
            getCartJSON(Utilities.renderCartFlyout, true);
          }
        },
        error: function (XMLHttpRequest, textStatus) {
          var data = eval('(' + XMLHttpRequest.responseText + ')');
          var response = data.description;
          var status = XMLHttpRequest.status;
          $addToCartBtn.removeClass('btn--loading');
          if (status === 422 && $('#productSelect option').length === 1) {
            const isBackInStockEnabled = document.querySelector('.product-variants')?.dataset.backInStockEnabled === 'true';
            $addToCartBtnText.text(isBackInStockEnabled ? liquidVars.addToBag : liquidVars.soldOut);
          }
          else {
            $addToCartBtn.prop('disabled', false).removeClass('disabled');
            $addToCartBtnText.text($addToCartBtn.attr('data-add-to-cart'));
          }
          if (status === 422) {
            $.ajax({
              url: '/cart.js', type: 'get', dataType: 'json',
              success: function (data) {
                const cart = data;
                const treeItem = cart.items.find(x => x.variant_id === parseInt(liquidVars.oneTreeProdID));
                let treeItemQty =  0;
                if(treeItem){
                  treeItemQty = treeItem.quantity;
                }
                if(treeItemQty < cart.item_count - treeItemQty){
                  $.ajax({
                    url: '/cart/add.js', type: 'post', dataType: 'json',
                    data: { id: parseInt(liquidVars.oneTreeProdID), quantity: cart.item_count - treeItemQty - treeItemQty },
                    success: async function (data, textStatus, jqXHR) {
                      Utilities.createCookie();
                      getCartJSON(Utilities.renderCartFlyout, true);
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                      errorCallback
                        ? errorCallback(jqXHR.responseJSON.description)
                        : alert(jqXHR.responseJSON.description);
                    }
                  });
                }
              }
            });
          } 
          $addToCartBtn.closest('.btn-wrap').append('<p class="note errors">' + response + '</p>');
          $addToCartBtn
              .removeClass('btn--loading')
              .prop('disabled', false)
              .removeClass('disabled btn--loading');

            $addToCartBtnText.text('Add To Cart');
            $addToCartBtnText.show();
            $('#AddToCartAdding').text('Adding...');
            $('#AddToCartAdding').hide();
        }
      });
    }
  };

  $addToCartBtn.on('click', addToCart);

  Lemonade.cache.$win.on('resize load', function (e) {
    Utilities.resizeCartFlyout();
    if (e.type == 'load') {
      setTimeout(function () {
        Utilities.resizeCartFlyout();
      }, 1500);
    }
  });

  // Enter on a <button> already fires click, so a keyup binding toggled it twice
  $('#CartTrigger').on('click', function (e) {
    e.stopPropagation();
    if (Lemonade.cache.$cartFlyout.hasClass('Show')) {
      Utilities.closeCartFlyout();
    } else {
      Utilities.openCartFlyout();
      Utilities.gamification();
      // Hide quick add modal on cart open
      $(".quick-add.show").removeClass("show")
    }
  });

  $('#CartFlyout .close-x').on('click keyup', function (e) {
    e.stopPropagation();
    if (e.type == "click" || e.which == 13) {
      Utilities.closeCartFlyout();
    }
  });

  Lemonade.cache.$cartFlyout
    .on('click keyup', '.FlyoutQty span', function (e) {
      if (e.type == "click" || e.which == 13) {
        Lemonade.quantitySelector(this, true);
      }
    })
    .on('change blur', '.FlyoutQty .Quantity', function (e) {
      var $qty = $(this),
          newQty = parseInt($qty.val()) || 0,
          variant_id = $qty.data('variant'),
          lineKey = $qty.attr('data-key'),
          handle = $qty.data('handle'),
          productGift = liquidVars.productGiftWomen || liquidVars.productGiftMen;

      // Block changing quantity for product gifts
      if (handle === productGift) {
        console.log("Can't change quantity for product gift");
        return;
      }

      // Ensure minimum quantity is 0
      if (newQty < 0) {
        newQty = 0;
        $qty.val(newQty);
      }

      // blur fires on a plain tab-through, so only talk to the cart when the value
      // really changed - otherwise the flyout re-renders and focus is thrown away
      const renderedQty = parseInt($qty.attr('value'), 10);
      if (newQty === renderedQty) return;
      $qty.attr('value', newQty);

      // Target this line item by its unique key (see quantitySelector) so a
      // duplicate variant on another line isn't changed too.
      Utilities.updateCartQuantity({ id: lineKey || variant_id, quantity: newQty }, function () {
        $qty.attr('value', newQty);
      }, false, true);
    })
    .on('click keydown', '.Remove', function (e) {
      if (e.type === "keydown") {
        if (e.which !== 13 && e.which !== 32) return;
        e.preventDefault();
      }
      // Remove only THIS line item: prefer its unique key so a duplicate of the
      // same variant on another line is not removed as well.
      const lineKey = $(this).attr('data-key');
      Utilities.updateCartQuantity({ id: lineKey || parseFloat($(this).attr('data-variant-id')), quantity: 0 }, false, false, true);
    });

  // #CartFlyout is role=dialog aria-modal, so focus stays in it until it is closed
  const flyout = document.getElementById('CartFlyout');
  const FLYOUT_FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), iframe, [tabindex]:not([tabindex="-1"])';
  const OTHER_LAYER = '[role="dialog"], [aria-modal="true"], [class*="klaviyo"], [class*="kl-private"]';
  const TOP_LAYER = '[role="dialog"], [aria-modal="true"], .klaviyo-close-form';

  if (flyout) {
    const isOpen = function () {
      return flyout.classList.contains('Show');
    };

    const flyoutFocusable = function () {
      return Array.from(flyout.querySelectorAll(FLYOUT_FOCUSABLE)).filter(function (el) {
        return el.getAttribute('aria-hidden') !== 'true' &&
          el.getClientRects().length > 0 &&
          getComputedStyle(el).visibility !== 'hidden';
      });
    };

    // the quick shop popup opens on top of the cart, and it owns the keyboard
    // until it closes - otherwise Tab pulls focus back out of it and Escape
    // would close both layers at once
    const layerAbove = function () {
      if (document.documentElement.classList.contains('_popup-opened')) return true;
      return Array.prototype.some.call(document.querySelectorAll(TOP_LAYER), function (el) {
        return el !== flyout && !flyout.contains(el) &&
          getComputedStyle(el).visibility !== 'hidden' &&
          el.getClientRects().length > 0;
      });
    };

    document.addEventListener('keydown', function (e) {
      if (!isOpen()) return;

      const escape = e.key === 'Escape' || e.key === 'Esc';
      if (!escape && e.key !== 'Tab') return;
      if (layerAbove()) return;

      if (escape) {
        e.preventDefault();
        Utilities.closeCartFlyout();
        return;
      }

      const items = flyoutFocusable();
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];

      if (!flyout.contains(document.activeElement)) {
        e.preventDefault();
        (e.shiftKey ? last : first).focus();
      } else if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });

    let mouseAt = 0;
    document.addEventListener('mousedown', function () {
      mouseAt = Date.now();
    }, true);

    // the express checkout buttons are iframes, so Tab can leave the panel without a
    // keydown this document ever sees
    document.addEventListener('focusin', function (e) {
      if (!isOpen() || flyout.contains(e.target)) return;
      if (Date.now() - mouseAt < 400) return;
      if (e.target.closest && e.target.closest(OTHER_LAYER)) return;
      const items = flyoutFocusable();
      (items[0] || flyout).focus({ preventScroll: true });
    });
  }

  getCartJSON(Utilities.renderCartFlyout, false, true);
  Utilities.resizeCartFlyout();
};

// Floating form labels
Lemonade.labels = function () {

  var $fieldInputs = $('.field-wrap').find('input').add('select').add('textarea');

  $fieldInputs.on('blur', function () {
    if ($(this).val() == '' || $(this).val() == null) {
      $(this).closest('.field-wrap').removeClass('float');
    }
  });

  $fieldInputs.on('click keyup', function (e) {
    if (e.type == 'click' || e.which == 13) {
      var $me = $(this);
      if ($me.is(':focus')) {
        $me.closest('.field-wrap').addClass('float');
      }
    }
  });

  $fieldInputs.bind("change keyup", function () {
    $(this).closest('.field-wrap').addClass('float');
  });

  function inputCheck() {
    $fieldInputs.each(function (i, el) {
      var $me = $(el);
      if ($me.is(':focus') || $me.is(':-webkit-autofill') || $me.val() != '') {
        $me.closest('.field-wrap').addClass('float');
      }
    });
  }

  $(window).on('load', function () {
    if ($fieldInputs.length > 0) {
      inputCheck();
    }
  });

};
// Collection page behavior
Lemonade.collectionPage = function () {

  var pageNumber = 1;

  // Grid Layout Toggle
  $('.grid-button').on('click', function () {
    if ($(this).hasClass('one-col')) {
      $(this).addClass('Active').siblings('.grid-button').removeClass('Active');
      $('.GridWrapper').addClass('one-col');
    } else {
      $(this).addClass('Active').siblings('.grid-button').removeClass('Active');
      $('.GridWrapper').removeClass('one-col');
    }
  });
function removerZerosDecimais() {
  const elementos = document.querySelectorAll('.money');
  elementos.forEach(el => {
    const original = el.textContent;
    const atualizado = original.replace(/([.,]00)(\s|$)/g, '$2');

    if (original !== atualizado) {
      el.textContent = atualizado;
    }
  });
}

  // Load more products into the page via AJAX API
  function loadMoreProducts(me, pageNumber, path) {
    var wrap = me.closest('.btn-wrap').closest('.GridWrapper').find('.AjaxPager'),
      maxpage = me.data('maxpage'),
      theQuery,
      url;

    if (!path) {
      path = location.pathname;
      theQuery = location.search;

      if (theQuery) {
        url = path + theQuery + '&page=' + pageNumber;
      } else {
        url = `${path}?page=${pageNumber}`;
      }
    }

    $.ajax({
      type: 'GET',
      dataType: 'html',
      url: url,
      data: theQuery,
      success: function (data) {
        var $data = $(data),
          $new_posts = $data.find('.AjaxPager').html();

        if ($data.length) {
          var $parsed = $('<div>').html($new_posts);
          if ($parsed.find('.item-product:not(.info-card)').length === 0) {
            me.hide();
            $('.LoadMoreWrapper').hide();
            return;
          }
          $('.AjaxPager').append($new_posts);
          Lemonade.lazyLoad();
          Lemonade.inView();
          me.attr('disabled', false);
          if (maxpage === pageNumber) {
            me.hide();
            $('.LoadMoreWrapper').hide();
          } else {
            me.attr('disabled', false);
          }
        }
      },
      error: function (data) {
        return wrap.append('<div>Something Went Wrong</div>');
      }
    });
  }
  // Trigger AJAX Load more on collection page
  $('#CollectionProductGrid').on('click', '#LoadMore', function (e) {
    pageNumber++;
    loadMoreProducts($(this), pageNumber);
  });

};
// Collection page behavior

Lemonade.collectionPageGift = function () {
  var pageNumbers = {};

  // Grid Layout Toggle
  $('.grid-button').on('click', function () {
    if ($(this).hasClass('one-col')) {
      $(this).addClass('Active').siblings('.grid-button').removeClass('Active');
      $('.GridWrapper').addClass('one-col');
    } else {
      $(this).addClass('Active').siblings('.grid-button').removeClass('Active');
      $('.GridWrapper').removeClass('one-col');
    }
  });

  // Load more products into the page via AJAX API
  function loadMoreProductsGift(me, collectionId, path) {
    if (!pageNumbers[collectionId]) {
      pageNumbers[collectionId] = 1;
    }

    var wrap = me.closest('.btn-wrap').closest('.GridWrapper').find('.AjaxPager'),
      maxpage = me.data('maxpage'),
      theQuery,
      url;

    if (!path) {
      path = location.pathname;
      theQuery = location.search;

      if (theQuery) {
        url = path + theQuery + '&page=' + pageNumbers[collectionId];
      } else {
        url = `${path}?page=${pageNumbers[collectionId]}`;
      }
    }

    $.ajax({
      type: 'GET',
      dataType: 'html',
      url: url,
      data: theQuery,
      success: function (data) {
        var $data = $(data),
          $new_posts = $data.find(`#collection-grid-${collectionId} .AjaxPager`).html();

        if ($data.length) {
          $(`#collection-grid-${collectionId} .AjaxPager`).append($new_posts);
          Lemonade.lazyLoad();
          Lemonade.inView();
          me.attr("disabled", false);
          if (maxpage === pageNumbers[collectionId]) {
            me.hide();
            me.closest('.LoadMoreWrapper').hide();
          } else {
            me.attr("disabled", false);
          }
        }
      },
      error: function (data) {
        return wrap.append('<div>Something Went Wrong</div>');
      }
    });
  }

  $('[id^="collection-grid-"]').each(function() {
    var $collection = $(this);
    var collectionId = $collection.attr('id').replace('collection-grid-', '');

    $collection.on('click', '#LoadMore', function (e) {
      e.preventDefault();
      if (!pageNumbers[collectionId]) {
        pageNumbers[collectionId] = 1;
      }
      pageNumbers[collectionId]++;
      loadMoreProductsGift($(this), collectionId);
    });
  });
};

// Blog and Collection page filtering
Lemonade.filtering = function () {

  var panel_height;

  function filterAndSort() {
    var $fakeSelect = $('.fake-select');

    $fakeSelect.on('click', '.OptionBox', function (e) {
      var $me = $(this);
      if ($me.hasClass('Active')) {
        $me
          .removeClass('Active')
          .attr('aria-expanded', 'false')
          .next('.OptionSelect')
          .removeClass('Show')
          .attr('aria-hidden', 'true');
      } else {
        $fakeSelect.find('.OptionBox').removeClass('Active').next('.OptionSelect').removeClass('Show').attr('aria-hidden', 'true');
        $me
          .addClass('Active')
          .attr('aria-expanded', 'true')
          .next('.OptionSelect')
          .addClass('Show')
          .attr('aria-hidden', 'false');
      }
    });

    $('.filterTrigger').on('click', function () {
      var $me = $(this),
        $mePanel = $me.attr('data-id');
      $me.toggleClass('Active');
      filterSortHeight();
      $($mePanel).toggleClass('Show');
    });

    $('.closeFilter').on('click', function () {
      $('.filterTrigger').removeClass('Active');
      $('.section-filters').add('#blog-filters').removeClass('Show');
    });
  }

  function filterSortHeight() {
    panel_height = $('.grid-item-1').innerHeight();
    $('.section-filters').add('#blog-filters').innerHeight(panel_height);
  }

  function filterBlog(val) {

    $('#blog-sort li').each(function (i, el) {
      var $me = $(el),
        filterVal = $me.data('filter-val');

      if (val == '' || val == null) {
        $me.removeClass('Hide');
      } else if (filterVal != val) {
        $me.addClass('Hide');
      } else {
        $me.removeClass('Hide');
      }

    });
  }

  $('#blog-search-input').on('keyup', function () {
    var $me = $(this);
    if ($me.val().length > 0) {
      $('#blog-update').removeClass('disabled');
    } else {
      $('#blog-update').addClass('disabled');
      $('#blog-sort li').removeClass('Hide');
    }
  });

  $('#blog-update').on('click', function () {
    searchVal = Utilities.handleize($('#blog-search-input').val());
    filterBlog(searchVal);
  });

  Lemonade.cache.$win.resize(filterSortHeight);

  filterAndSort();

};

// Product listings features (image swap on swatch click and quickshop add to cart)
Lemonade.quickShopAndImageSwap = function () {

  var $gridWrapper = $('body');

  function quickshopAddToCart(handle, productId, option1, option2) {

    var variantLookup = 'just_product';
    if (option1 && option2) {
      variantLookup = 'both';
    } else if (option1) {
      variantLookup = 'option1';
    } else if (option2) {
      variantLookup = 'option2';
    }

    $.ajax({
      url: `/products/${handle}?view=json`,
      dataType: 'html',
      async: true,
      success: function (meta) {
        var fields = JSON.parse(meta);
        $.each(fields.variants, function (i, el) {
          if (variantLookup == 'both') {
            if (el.option1 == option1 && el.option2 == option2) {
              Utilities.addProductToCart({ id: el.id, quantity: 1 });
              requestCloseQuickAdd(productId);
              return false;
            }
          } else if (variantLookup == 'option1') {
            if (el.option1 == option1) {
              Utilities.addProductToCart({ id: el.id, quantity: 1 });
              requestCloseQuickAdd(productId);
              return false;
            }
          } else if (variantLookup == 'option2') {
            if (el.option2 == option2) {
              Utilities.addProductToCart({ id: el.id, quantity: 1 });
              requestCloseQuickAdd(productId);
              return false;
            }
          }

        });
      }
    });
  };

  function inventoryQuickshop(el, me) {
    if (el.quantity > 1) {
      me.addClass('soldout sold-out');
    } else {
      me.removeClass('soldout sold-out');
    }
  }

  function openQuickAdd(triggerEl) {
    closeQuickAdd();
    $me = $(triggerEl);
    $me.parent().parent().addClass('show mobile');
  }

  function closeQuickAdd() {
    $(".quick-add.show").removeClass('show mobile');
  }

  function requestCloseQuickAdd(productId) {
    setTimeout(function(){
      closeQuickAdd();
      if(productId)
        resetLoadingQuickAdd(productId);

    }, 1000)
  }

  function showLoadingQuickAdd(productId) {
    $(`#quick-add-button-${productId}`).attr("disabled", "disabled");
    $(`#quick-add-button-${productId} span`).html("ADDED...");
  }

  function resetLoadingQuickAdd(productId) {
    $(`#quick-add-button-${productId} span`).html("QUICK ADD");
    $(`#quick-add-button-${productId}`).removeAttr("disabled");
  }

  function syncLegacyCardHoverState($product, mainImageUrl, hoverImageUrl) {
    var $itemImage = $product.find('.item-img');
    var $hoverContainer = $product.find('#item-product-img-hover');
    var hasDistinctHover = !!hoverImageUrl && hoverImageUrl !== mainImageUrl;

    if (!$hoverContainer.length && hoverImageUrl) {
      var $mainImageContainer = $product.find('.product-card-link .main-img').first();
      if ($mainImageContainer.length) {
        $hoverContainer = $('<div id="item-product-img-hover" class="hover-img item-product-img"><img width="700" height="700" alt="Image" loading="lazy"></div>');
        $mainImageContainer.after($hoverContainer);
      }
    }

    if ($hoverContainer.length) {
      var $hoverImage = $hoverContainer.find('img');
      if (!$hoverImage.length) {
        $hoverImage = $('<img width="700" height="700" alt="Image" loading="lazy">');
        $hoverContainer.empty().append($hoverImage);
      }

      if (hoverImageUrl) {
        $hoverImage.attr('src', hoverImageUrl);
        $hoverImage.attr('data-src', hoverImageUrl);
        $hoverImage.attr('data-lazy', hoverImageUrl);
      }
    }

    $itemImage.toggleClass('has-hover', hasDistinctHover);
  }

  // Open quick add modal
  $gridWrapper.on('click', '.quick-add-button', function() {
    openQuickAdd(this);

    var currentProductId = $(this).attr("data-id");
    var swatchButtons = document.querySelectorAll(`#product-${currentProductId} .quickshop-wrap .swatches button`);
    let activeSwatchIndex = -1;

    for (var i = 0; i < swatchButtons.length; i++) {
        if (swatchButtons[i].classList.contains("Active")) {
            activeSwatchIndex = i;
            break;
        }
    }

    if (activeSwatchIndex == -1) {
        swatchButtons[0].click();
    }
  });

  // Close quick add modal
  $gridWrapper.on('click', '.quick-add-content .button-close', function(){
    closeQuickAdd();
  });

  // Preload variant images on hover
  $gridWrapper.on('mouseenter', '.swatchTrigger', function () {
    var $me = $(this),
      thisImage = $me.attr('data-image-toggle'),
      $meProduct = $me.closest('.item-product');

    const productImage = $meProduct.find(`.${thisImage} img`);
    if (productImage.attr('src') !== productImage.attr('data-src'))
      productImage.attr("src", productImage.attr('data-src'));
  });

  // Swap the image and set the color selection in preparation for quickshop add to cart.
  $gridWrapper.on('click', '.swatchTrigger', function () {
    var $me = $(this),
      thisImage = $me.attr('data-image-toggle'),
      meProductId = $me.attr('data-product-id'),
      meColorImage = $me.attr('data-image'),
      meHoverImage = $me.attr('data-hover-image'),
      meColor = $me.attr('data-color'),
      meColorClass = Utilities.handleize(meColor),
      $meProduct = $me.closest('.item-product'),
      meProductSubmit = $me.attr('data-submit-button'),
      prod_handle = $me.attr('data-handle'),
      // get swatches on quickshop and on quickadd modal
      currentColorSwatches = $('.' + Array.from($me[0].classList).join('.'));

    $.ajax({
      url: `/products/${prod_handle}?view=json`,
      dataType: 'html',
      async: true,
      success: function (meta) {
        var fields = JSON.parse(meta),
          variants = fields.variants;

        $meProduct.find('.sizeOptions button').each(function (i, el) {
          var $me = $(el),
            sizeOption = $me.data('size');

          // Only show available sizes
          const currentColorAndSizeVariant = variants.find(variant =>
              variant &&
              String(variant.option2) === String(meColor) &&
              String(variant.option1) === String(sizeOption)
          );
          if (currentColorAndSizeVariant && currentColorAndSizeVariant.quantity > 0) {
            $me.show()
          } else {
            $me.hide()
          }

        });
        $(meProductSubmit).find('.sizeOptions').removeClass('needsColorSelection');
        $(meProductSubmit).attr('data-selected-color', meColor);

        if (!$me.hasClass('Active')) {
          colorOption = meColor;
          currentColorSwatches.addClass('Active').siblings('.swatch').removeClass('Active');

          //Lazy load variant image
          const productImage = $meProduct.find(`.${thisImage} img`);
          if (productImage.attr('src') !== productImage.attr('data-src'))
            productImage.attr("src", productImage.attr('data-src'));
          //Toggle image and hide images of other colors
          $meProduct.find(`.${thisImage}`).show().siblings('.color-image').hide();
          syncLegacyCardHoverState($meProduct, productImage.attr('src') || meColorImage, meHoverImage);
          //Toggle image on quick add modal mobile
          $(`#product-${meProductId} .quick-add-content-images img`).attr('src', meColorImage);

          $meProduct.find('.selected-color').text(meColor).end().find('.selected-swatch span').removeAttr('class').addClass('swatch').addClass(meColorClass)
        }
      }
    });

  });

  $gridWrapper.on('click', '.quickshop-wrap', function () {
    var $me = $(this);
    if (!bodyClasses.contains('NarrowScreen')) {
      $me.find('.btn-addtocart').css('display', 'flex');
    }
  });

  $gridWrapper.on('click', '.item-product #mobileSizesTrigger', function (e) {
    e.stopPropagation();

    var $me = $(this),
      $meBtn = $me.closest('.item-product').find('.btn-addtocart');

    $('#ScreenOverlay').addClass('Active');
    Lemonade.scrollNo();
    $meBtn.css('display', 'flex');
  });

  $gridWrapper.on('keydown', '.item-product #mobileSizesTrigger', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.keyCode !== 13 && e.keyCode !== 32) return;
    e.preventDefault();
    $(this).trigger('click');
  });

  $('#ScreenOverlay').on('click', function () {
    if (Lemonade.cache.$cartFlyout.hasClass('Show')) {
      Utilities.closeCartFlyout();
    }
    $(this).removeClass('Active');
    $('.GridWrapper').find('.btn-addtocart').css('display', 'none');
    Lemonade.scrollYes();
  })

  $gridWrapper.on('mouseenter', '.btn-addtocart', function () {
    var $me = $(this);
    $me.find('.sizeOptions').css('display', 'flex');
  });

  $gridWrapper.on('mouseleave', '.btn-addtocart', function () {
    var $me = $(this);

    $me.find('.sizeOptions').css('display', 'none');
  });

  // Show the Size options
  $gridWrapper.on('click', '.quickshopTrigger', function () {
    var $me = $(this);
    if ($me.hasClass('Active')) {
      $me.attr('aria-expanded', 'false');
      $me.removeClass('Active').find('.sizeOptions').attr('aria-hidden', 'true');
    } else {
      $me.attr('aria-expanded', 'true');
      $me.addClass('Active').find('.sizeOptions').attr('aria-hidden', 'false');
    }
  });

  // Set the size selection in preparation for quickshop add to cart
  $gridWrapper.on('click', '.sizeOptions button', function (e) {
    e.stopPropagation();

    var $me = $(this),
      meSize = $me.attr('data-size'),
      meProduct = $me.attr('data-main-product'),
      meProductId = $me.attr('data-product-id'),
      meQuickshopData = $me.attr('data-quickshop-data'),
      meColor = $(meQuickshopData).attr('data-selected-color');

    if (!$me.hasClass('Active')) {
      $me.addClass('Active').siblings().removeClass('Active');
      showLoadingQuickAdd(meProductId);
      if ($me.hasClass('can_submit')) {
        quickshopAddToCart(meProduct, meProductId, meSize, false);
      } else {
        quickshopAddToCart(meProduct, meProductId, meSize, meColor);
      }
      $me.removeClass('Active');
    }
  });

  $gridWrapper.on('mouseenter', '.sizeOptions button', function () {
    var $me = $(this),
      siblings = $me.siblings('button');
    siblings.addClass('deactivate');
    $me.closest('.sizeOptions').prev('.btn-addtocart').addClass('Show');
  });

  $gridWrapper.on('mouseleave', '.sizeOptions button', function () {
    var $me = $(this),
      siblings = $me.siblings('button');
    siblings.removeClass('deactivate');
    $me.closest('.sizeOptions').prev('.btn-addtocart').removeClass('Show');
  });

  // Collapse quickshop sizes on mouseleave of the product item
  $gridWrapper.on('mouseenter', '.item-product .item-img', function () {
    var $me = $(this);
    setTimeout(function () {
      $me.addClass('ShowSizes');
    }, 150);
  });

  $gridWrapper.on('mouseleave', '.item-product .item-img', function () {
    $(this).removeClass('ShowSizes').find('.quickshopTrigger').removeClass('Active');
  });

  $gridWrapper.on('mouseenter', '.item-product', function () {
    var $me = $(this),
      mequickshop = $me.attr('id'),
      mefirstColor = $(`div[data-product="#${mequickshop}"]`).find('.swatchTrigger.Active'),
      meColor = mefirstColor.attr('data-color'),
      prod_handle = mefirstColor.attr('data-handle');

    if (mefirstColor.length == 0) return false;

    $.ajax({
      url: '/products/' + prod_handle + '?view=json',
      dataType: 'html',
      async: true,
      success: function (meta) {
        var fields = JSON.parse(meta),
          variants = fields.variants;

        $me.find('.size-options button').each(function (i, el) {
          var $me = $(el),
            me_val = $me.data('size');

          // Only show available sizes
          const currentColorAndSizeVariant = variants.find(variant =>
              variant &&
              String(variant.option2) === String(meColor) &&
              String(variant.option1) === String(me_val)
          );
          if (currentColorAndSizeVariant && currentColorAndSizeVariant.quantity > 0) {
            $me.show()
          } else {
            $me.hide()
          }

        });
      }
    });

  });
};

// Cart page functionality
Lemonade.cartPage = function () {

  $('.cart-body')
    .on('click keyup', '.CartQty span', function (e) {
      if (e.type == "click" || e.which == 13) {
        Lemonade.quantitySelector(this, false);
      }
    })
    .on('change blur', '.CartQty .Quantity', function (e) {
      var $qty = $(this),
          newQty = parseInt($qty.val()) || 0,
          variant_id = $qty.data('variant'),
          lineKey = $qty.attr('data-key'),
          handle = $qty.data('handle'),
          productGift = liquidVars.productGiftWomen || liquidVars.productGiftMen;

      // Block changing quantity for product gifts
      if (handle === productGift) {
        console.log("Can't change quantity for product gift");
        return;
      }

      // Ensure minimum quantity is 0
      if (newQty < 0) {
        newQty = 0;
        $qty.val(newQty);
      }

      // blur fires on a plain tab-through, so only talk to the cart when the value
      // really changed - otherwise the page re-renders and focus is thrown away
      const renderedQty = parseInt($qty.attr('value'), 10);
      if (newQty === renderedQty) return;
      $qty.attr('value', newQty);

      // Target this line item by its unique key so a duplicate variant on another
      // line isn't changed too.
      Utilities.updateCartQuantity({ id: lineKey || variant_id, quantity: newQty }, function () {
        $qty.attr('value', newQty);
      }, false, false);
    })
    .on('click keydown', '.Remove', function (e) {
      if (e.type === "keydown") {
        if (e.which !== 13 && e.which !== 32) return;
        e.preventDefault();
      }
      // Remove only THIS line item via its unique key (see flyout Remove).
      const lineKey = $(this).attr('data-key');
      Utilities.updateCartQuantity({ id: lineKey || parseFloat($(this).attr('data-variant-id')), quantity: 0 }, false, false, false);
    });

  const initialCart = getInitialCartJson();
  if (initialCart) {
    Utilities.renderCartPage(initialCart);
  } else {
    $.getJSON('/cart.js', function (cart) {
      Utilities.renderCartPage(cart);
    });
  }

};

// Content accordions within content editors (page.narrow.liquid template)
// format rules: <h2></h2> to designate a block of accordions within a category heading, <h3></h3> To designate a trigger. All content between h3's will be collapsed.
Lemonade.pageAccordions = function () {

  $('#faqs .rte > p strong').each(function (i, el) {
    $(el).closest('p').replaceWith(`<div class="AccTrigger" role="button" aria-expanded="false" tabindex="0">${$(el).html()}<span class="plus-sign"></span></div>`);
  });

  $('#faqs .rte > .AccTrigger').each(function (i, el) {
    $(el).nextUntil(".AccTrigger").wrapAll('<div class="AccContent" aria-hidden="true"></div>');
  });

  // $('#faqs .rte > .AccTrigger').each(function(i,el){
  //   $(el).nextUntil(".AccTrigger").andSelf().wrapAll('<div class="acc-item"></div>');
  // });


  Lemonade.accordion($('#faqs .AccTrigger'), $('#faqs .AccContent'));
};

// Custom video player UI (play button overlay and video start)
Lemonade.videoPlayer = function () {

  $('.video-thumbnail').on('click', function () {
    var $me = $(this);
    $me.hide();
    $me.next('video').trigger('play');
  });

  $('.video-container video').on('click', function () {
    var $me = $(this);
    $me.prev('.video-thumbnail').show();
    $me.trigger('pause');
  });
};

document.addEventListener('DOMContentLoaded', function () {
 if (this.location.pathname == '/a/wishlist') {
    const initialCart = getInitialCartJson();
    if (initialCart) {
      if(initialCart.items.length > 0){
        checkOneTree(initialCart, false);
      }
    } else {
      $.getJSON('/cart.js', function (cart) {
        if(cart.items.length > 0){
          checkOneTree(cart, false);
        }
      });
    }
  }
})

function checkOneTree(cart, openCart) {
  if (liquidVars.oneTreeProdID && liquidVars.oneTreeProdHandle) {
    var nonTreeItemCount = 0;
    var oneTreeCount = 0;

    $.each(cart.items, function (i, el) {
      if (el.handle != liquidVars.oneTreeProdHandle) {
        nonTreeItemCount = nonTreeItemCount + el.quantity;
      } else {
        oneTreeCount = oneTreeCount + el.quantity;
      }
    });

    if(oneTreeCount > 0){
      $.ajax({
        url: '/cart/change.js',
        type: 'post',
        dataType: 'json',
        data: { id: liquidVars.oneTreeProdID, quantity: nonTreeItemCount },
        success: function (cart) {
          if (document.getElementById('CartFlyout')) {
            Utilities.updateCart(cart, openCart);
          }
        },
        error: function (XMLHttpRequest, textStatus) {
          Shopify.onError(XMLHttpRequest, textStatus);
        }
      });
    } else {
      $.ajax({
        url: '/cart/add.js', type: 'post', dataType: 'json',
        data: { id: parseInt(liquidVars.oneTreeProdID), quantity: nonTreeItemCount },
        success: async function (data, textStatus, jqXHR) {
          if (document.getElementById('CartFlyout')) {
            Utilities.updateCart(cart, openCart);
          }
        },
        error: function (XMLHttpRequest, textStatus) {
          Shopify.onError(XMLHttpRequest, textStatus);
        }
      });
    }
  }
}


// Add Handling For Shop The Look widget add to cart
$('body').on('stl.updateCartDetails', function (evt, cart) {
  const colorUpdate = function (cart) {
    cart.items.map(async item => {
      const colorValue = item.options_with_values.filter(x => x.name === "Color");
      if (colorValue.length > 0) {
        const color = Utilities.getColorNameByCode(colorValue[0].value);
        if (color && document.querySelector(`.item-cart-${item.handle} .colorName`)) {
          document.querySelector(`.item-cart-${item.handle} .colorName`).innerHTML = `Color: <span style="text-transform: uppercase">${color["COLOR NAME"]}</span>`
        }

      }
    })
  };
  colorUpdate(cart)
  //Utilities.updateCart(colorUpdate(cart), true);
  checkOneTree(cart, true);

});

// The wishlist app makes its hearts role="button" tabindex="0" but only binds click,
// so Enter/Space never reach it.
(function () {
  const HEART = '.smartwishlist[role="button"], .smartwishlist[tabindex]';
  const ANY_HEART = '.smartwishlist';

  // the app owns aria-label and re-renders the heart on toggle, so only mirror the state
  function syncHeart(heart) {
    const added = heart.classList.contains('bookmarked') || !!heart.querySelector('.fa-heart');
    const pressed = added ? 'true' : 'false';
    if (heart.getAttribute('aria-pressed') !== pressed) heart.setAttribute('aria-pressed', pressed);
  }

  // the app rewrites the heart's own classes or swaps its icon on toggle, so each heart
  // gets its own watcher - cheaper than watching class changes across the whole page
  const WATCHED = 'lvHeartWatched';

  // On touch screens the popover only flashes on a tap - there is no hover to show it for -
  // so it is switched off there. The app tooltipsters a heart after the theme first sees it
  // (and again after a reload), hence the class watcher below.
  const noHover = window.matchMedia ? window.matchMedia('(hover: none)') : null;

  function disableTooltipOnTouch(heart) {
    if (!noHover || !noHover.matches || !heart.classList.contains('tooltipstered')) return;
    if (!window.jQuery || !jQuery.fn.tooltipster) return;
    tooltipCall(heart, 'disable');
  }

  function updateHeart(heart) {
    syncHeart(heart);
    disableTooltipOnTouch(heart);
  }

  function watchHeart(heart) {
    if (heart.dataset[WATCHED]) return;
    heart.dataset[WATCHED] = 'true';
    new MutationObserver(function () { updateHeart(heart); })
      .observe(heart, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'role', 'tabindex'] });
  }

  function adoptHeart(heart) {
    updateHeart(heart);
    watchHeart(heart);
  }

  function syncWithin(root) {
    if (root.matches && root.matches(ANY_HEART)) adoptHeart(root);
    if (root.querySelectorAll) root.querySelectorAll(ANY_HEART).forEach(adoptHeart);
  }

  // iOS takes a tap as a hover whenever that hover reveals something - and the card's hover
  // styles and handlers do - then drops the tap's click, so a card heart only toggled on the
  // second tap. A tap on it is turned into its click right away; with the touchend cancelled
  // no emulated mouse events or click follow, so the app still sees exactly one click.
  const CARD_HEART = '.item-product .smartwishlist';
  const TAP_SLOP = 10;
  let tapStart = null;

  document.addEventListener('touchstart', function (e) {
    const heart = e.touches.length === 1 && e.target.closest && e.target.closest(CARD_HEART);
    tapStart = heart ? { target: e.target, heart: heart, x: e.touches[0].clientX, y: e.touches[0].clientY } : null;
  }, { passive: true });

  document.addEventListener('touchcancel', function () { tapStart = null; }, { passive: true });

  document.addEventListener('touchend', function (e) {
    const tap = tapStart;
    tapStart = null;
    if (!tap || e.touches.length || e.changedTouches.length !== 1) return;
    const touch = e.changedTouches[0];
    if (Math.abs(touch.clientX - tap.x) > TAP_SLOP || Math.abs(touch.clientY - tap.y) > TAP_SLOP) return;
    if (!tap.heart.contains(document.elementFromPoint(touch.clientX, touch.clientY))) return;
    e.preventDefault();
    // the touched node itself, in case the app listens on the icon; an SVG has no click()
    (typeof tap.target.click === 'function' ? tap.target : tap.heart).click();
  }, { passive: false });

  document.addEventListener('keydown', function (e) {
    const heart = e.target.closest && e.target.closest(HEART);
    if (!heart) return;
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar' && e.keyCode !== 13 && e.keyCode !== 32) return;
    e.preventDefault();
    heart.click();
  });

  // the app's wishlist popover is a Tooltipster v3 node appended to <body> and shown on hover
  // only, so the link it holds - the only path to the wishlist page - never reaches the keyboard
  const TIP = '.tooltipster-base';
  let openHeart = null;
  let dismissed = false;

  function tooltipOf(heart) {
    if (!window.jQuery || !jQuery.fn.tooltipster) return null;
    if (!heart.classList.contains('tooltipstered')) return null;
    let el;
    try { el = jQuery(heart).tooltipster('elementTooltip'); } catch (e) { return null; }
    if (!el) return null;
    return el.jquery ? el[0] : el;
  }

  function tooltipLink(heart) {
    const tip = tooltipOf(heart);
    return tip ? tip.querySelector('a[href]') : null;
  }

  function tooltipCall(heart, method) {
    try { jQuery(heart).tooltipster(method); } catch (e) {}
  }

  function closeTooltip() {
    if (openHeart && document.contains(openHeart)) tooltipCall(openHeart, 'hide');
    openHeart = null;
  }

  function keyboardFocused(el) {
    try { return el.matches(':focus-visible'); } catch (e) { return true; }
  }

  // the popover sits last in <body>, so a native Tab out of it would skip the rest of the page
  function nextTabbableAfter(el) {
    const all = Array.from(document.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter((node) => node.getClientRects().length > 0 && !node.closest(TIP));
    const i = all.indexOf(el);
    return i === -1 ? null : all[i + 1] || null;
  }

  document.addEventListener('focusin', function (e) {
    const heart = e.target.closest && e.target.closest(HEART);

    if (heart) {
      if (heart !== openHeart) dismissed = false;
      // hover already covers the mouse, and showing it on a click would leave it stuck open
      if (dismissed || !keyboardFocused(heart)) return;
      openHeart = heart;
      tooltipCall(heart, 'show');
      return;
    }

    if (!openHeart) return;
    const tip = tooltipOf(openHeart);
    if (tip && tip.contains(e.target)) return;
    dismissed = false;
    closeTooltip();
  });

  document.addEventListener('keydown', function (e) {
    if (!openHeart || !document.contains(openHeart)) return;

    // WCAG 1.4.13 wants a dismiss that does not move focus
    if (e.key === 'Escape' || e.key === 'Esc') {
      const tip = tooltipOf(openHeart);
      dismissed = true;
      if (tip && tip.contains(document.activeElement)) openHeart.focus();
      closeTooltip();
      return;
    }

    if (e.key !== 'Tab') return;
    const link = tooltipLink(openHeart);
    if (!link) return;

    if (!e.shiftKey && document.activeElement === openHeart) {
      e.preventDefault();
      link.focus();
    } else if (e.shiftKey && document.activeElement === link) {
      e.preventDefault();
      openHeart.focus();
    } else if (!e.shiftKey && document.activeElement === link) {
      const after = nextTabbableAfter(openHeart);
      e.preventDefault();
      closeTooltip();
      if (after) after.focus();
    }
  });

  // infinite scroll, filter re-renders and recommendation hydration all add hearts
  // long after load, so pick them up from what was inserted rather than on a timer
  let pending = [];
  let queued = false;
  new MutationObserver(function (records) {
    for (let i = 0; i < records.length; i++) {
      const added = records[i].addedNodes;
      for (let j = 0; j < added.length; j++) {
        if (added[j].nodeType === 1) pending.push(added[j]);
      }
    }
    if (!pending.length || queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      const roots = pending;
      pending = [];
      roots.forEach(function (root) {
        if (root.isConnected) syncWithin(root);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { syncWithin(document.documentElement); });
  } else {
    syncWithin(document.documentElement);
  }
})();

// Initialize Lemonade JS on docready
$(Lemonade.init);


(function () {
  const MODAL = '.gamification-modal';
  const ITEM = '.gender-selector, .gift-option-value';
  let giftReturnFocus = null;

  function groupItems(group) {
    return Array.from(group.querySelectorAll(ITEM)).filter((el) => el.getClientRects().length > 0);
  }

  // the modal's own code owns the .active class, so mirror it instead of duplicating the logic
  function syncGroup(group) {
    groupItems(group).forEach((el) => {
      const checked = el.classList.contains('active') ? 'true' : 'false';
      if (el.getAttribute('aria-checked') !== checked) el.setAttribute('aria-checked', checked);
      const tabindex = checked === 'true' ? '0' : '-1';
      if (el.getAttribute('tabindex') !== tabindex) el.setAttribute('tabindex', tabindex);
    });
  }

  function syncAll(modal) {
    modal.querySelectorAll('[role="radiogroup"]').forEach(syncGroup);
  }

  function focusable(modal) {
    return Array.from(modal.querySelectorAll('a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])'))
      .filter((el) => !el.disabled && el.getAttribute('aria-hidden') !== 'true' &&
        el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden');
  }

  function init(modal) {
    syncAll(modal);

    new MutationObserver(function () { syncAll(modal); })
      .observe(modal, { subtree: true, attributes: true, attributeFilter: ['class'] });

    // a cart render re-adds .open to an already open modal, and focus must not be taken again then
    let wasOpen = modal.classList.contains('open');

    new MutationObserver(function () {
      const isOpen = modal.classList.contains('open');
      if (isOpen === wasOpen) return;
      wasOpen = isOpen;

      if (isOpen) {
        giftReturnFocus = document.activeElement;
        const container = modal.querySelector('.gamification-modal-container') || modal;
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            if (modal.classList.contains('open')) container.focus();
          });
        });
      } else if (giftReturnFocus && document.contains(giftReturnFocus)) {
        giftReturnFocus.focus();
        giftReturnFocus = null;
      }
    }).observe(modal, { attributes: true, attributeFilter: ['class'] });

    // Escape and the focus trap have to work wherever focus currently sits
    document.addEventListener('keydown', function (e) {
      if (!modal.classList.contains('open')) return;

      if (e.key === 'Escape' || e.key === 'Esc') {
        const close = modal.querySelector('.gamification-modal__close');
        if (close) {
          e.preventDefault();
          close.click();
        }
        return;
      }

      if (e.key === 'Tab') {
        const list = focusable(modal);
        if (!list.length) return;
        const first = list[0];
        const last = list[list.length - 1];
        if (!modal.contains(document.activeElement)) {
          e.preventDefault();
          first.focus();
        } else if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
        return;
      }

      const current = e.target.closest(ITEM);
      if (!current) return;
      const group = current.closest('[role="radiogroup"]');
      if (!group) return;

      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        current.click();
        return;
      }

      const list = groupItems(group);
      const index = list.indexOf(current);
      if (index === -1) return;
      let next = -1;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (index + 1) % list.length;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (index - 1 + list.length) % list.length;
      else if (e.key === 'Home') next = 0;
      else if (e.key === 'End') next = list.length - 1;
      else return;

      e.preventDefault();
      list[next].focus();
      list[next].click();
    });
  }

  function boot() {
    document.querySelectorAll(MODAL).forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
